// @ts-nocheck — звичайний JavaScript для браузера, без типів TypeScript
// ===== STATE =====
const STATE = {
  figures: [],
  currentIdx: 0,
  currentNav: 'figures',
  _savedState: null,
  _discountPct: 0,
  _accBackShown: false
};

let setupSlots = [];

const STAND_COLORS = [
  { id:1,  name:'Чорний',       color:'#1C1C1C' },
  { id:2,  name:'Коричневий',   color:'#7B4B2A' },
  { id:3,  name:'Білий',        color:'#F0EBE3' },
  { id:4,  name:'Блакитний',    color:'#00B4D8' },
  { id:5,  name:'Рожевий',      color:'#F472B6' },
  { id:6,  name:'Тілесний',     color:'#E8B89A' },
  { id:7,  name:'Жовтий',       color:'#FCD34D' },
  { id:8,  name:'Рудий',        color:'#C2622D' },
  { id:9,  name:'Зелений',      color:'#4ADE80' },
  { id:10, name:'Червоний',     color:'#EF4444' },
  { id:11, name:'Помаранчевий', color:'#FB923C' },
  { id:12, name:'Сірий',        color:'#9CA3AF' },
];

function newFigure(type) {
  return {
    type, skin:'flesh', face:0,
    hairType:'bald', hairColor:'#B5A585', hairStyle:11, hatStyle:1,
    torsoColor:'flesh', sleeveColor:'flesh',
    printCat:null, print:null,
    legsType:'normal', legsColor:'flesh',
    accLeft:null, accRight:null,
    keychain:false, package:'transport',
    customPaint:false, paintPhotos:[], paintPhotoUrls:[],
    animalType:1,
    itemId:null,      // для типу 'item' — який саме предмет обрано
    readyId:1,        // для типу 'ready' — яке готове тіло обрано
    facing:'front',
    stand:false, standColor:1,
    heartKeychain:false
  };
}

// Підставка тимчасово прибрана з продажу. Код лишається на місці —
// щоб повернути, досить поставити false.
const STAND_OFF = true;
// Ті, хто вже встиг обрати підставку до її зняття, не мають бачити її на фігурці.
function figStand(f) { return !STAND_OFF && !!(f && f.stand); }

// ===== PRICES =====
function figurePrice(fig) {
  if (!fig) return 0;
  if (fig.type === 'item') return PRICES.accessory;   // предмет — за ціною аксесуара
  let p = fig.type === 'ready' ? PRICES.ready
        : fig.type === 'human' ? PRICES.human : PRICES.animal;
  if (fig.keychain)      p += fig.type === 'human' ? PRICES.keychain_human : PRICES.keychain_animal;
  if (fig.print)         p += PRICES.print;
  // Боксерські рукавички займають обидві руки, але це один аксесуар
  const isBoxing = fig.accLeft === 'boxing' || fig.accRight === 'boxing';
  if (isBoxing) {
    p += PRICES.accessory;
  } else {
    if (fig.accLeft)  p += PRICES.accessory;
    if (fig.accRight) p += PRICES.accessory;
  }
  if (fig.customPaint)   p += PRICES.customPaint;
  if (fig.stand && !STAND_OFF) p += 30;
  if (fig.heartKeychain) p += PRICES.heartKeychain;
  return p;
}
function totalPrice() { return STATE.figures.reduce((s, f) => s + figurePrice(f), 0); }
function updatePrices() {
  const cur = STATE.figures[STATE.currentIdx];
  document.getElementById('stagePriceVal').textContent = (cur ? figurePrice(cur) : 0) + ' грн';
  document.getElementById('topTotalPrice').textContent = totalPrice() + ' грн';
  refreshFigChip();
}
// оновлення мініатюри поточної фігурки у смузі (з дебаунсом)
let _figChipTimer = null;
function refreshFigChip() {
  clearTimeout(_figChipTimer);
  _figChipTimer = setTimeout(() => {
    // оновлюємо лише поточний чіп — решта не змінилась
    if (typeof fillFigChips === 'function') fillFigChips(STATE.currentIdx);
  }, 400);
}

// ===== PRELOADER =====
window.addEventListener('load', () => {
  if (window.MB_EMBED) return;   // вбудований режим — запускає редактор рамок
  const bar = document.getElementById('preBar');
  let w = 0;
  const iv = setInterval(() => {
    w = Math.min(w + Math.random() * 22 + 6, 100);
    bar.style.width = w + '%';
    if (w >= 100) {
      clearInterval(iv);
      setTimeout(() => {
        document.getElementById('preloader').classList.add('hidden');
        initApp();
      }, 400);
    }
  }, 280);
});

function initApp() {
  let saved = null;
  try { saved = localStorage.getItem('brickstudio_state'); } catch (e) {}
  if (saved) {
    try {
      const s = JSON.parse(saved);
      if (s.figures && s.figures.length > 0) {
        STATE._savedState = s;
        const btnC = document.getElementById('btnContinue');
        btnC.style.display = 'flex';
        document.getElementById('continueDesc').textContent = `Незавершений набір: ${s.figures.length} фігур`;
      }
    } catch(e) {}
  } else {
    document.getElementById('welcomeCards').classList.add('single');
  }
  showOverlay('overlayWelcome');
}

function showOverlay(id) {
  document.getElementById(id).classList.add('active');
  if (id === 'overlayAddChar') fillTypePreviews();
}
function hideOverlay(id) { document.getElementById(id).classList.remove('active'); }
function goToHairFromKeychain() { hideOverlay('overlayBaldKeychain'); setNav('hair'); }

function continueEditing() {
  if (STATE._savedState) {
    STATE.figures = STATE._savedState.figures;
    STATE.currentIdx = STATE._savedState.currentIdx || 0;
  }
  hideOverlay('overlayWelcome');
  launchConstructor();
}

function startFresh() {
  setupSlots = [{ type: null }];
  renderSetupSlots();
  hideOverlay('overlayWelcome');
  showOverlay('overlaySetup');
}

// ===== SETUP SLOTS =====
function renderSetupSlots() {
  const container = document.getElementById('setupSlots');
  container.innerHTML = '';
  setupSlots.forEach((slot, i) => {
    const row = document.createElement('div');
    row.className = 'figset-row';
    const label = i === 0 ? 'Фігурка 1 (основна)' : (slot.type === 'animal' ? `Тваринка ${i+1}` : `Фігурка ${i+1}`);
    row.innerHTML = `
      <div class="figset-row-label">
        <span>${label.toUpperCase()}</span>
        <div style="display:flex;align-items:center;gap:6px">
          ${i===0 ? '<span class="figset-badge">основна</span>' : ''}
          ${i>0 ? `<span class="figset-row-del" onclick="removeSetupSlot(${i})">✕</span>` : ''}
        </div>
      </div>
      <div class="figset-choices">
        <div class="figset-choice ${slot.type==='human'?'selected':''}" onclick="selectSlotType(${i},'human')">
          <span class="figset-choice-icon" id="setPrevH-${i}">🧍</span>
          <div class="figset-choice-name">Людина</div>
          <div class="figset-choice-price">від 120 грн</div>
        </div>
        <div class="figset-choice ${slot.type==='animal'?'selected':''}" onclick="selectSlotType(${i},'animal')">
          <span class="figset-choice-icon" id="setPrevA-${i}">🐾</span>
          <div class="figset-choice-name">Тваринка</div>
          <div class="figset-choice-price">від 50 грн</div>
        </div>
      </div>`;
    container.appendChild(row);
    defaultPreview('human',  'setPrevH-' + i);
    defaultPreview('animal', 'setPrevA-' + i);
  });
}
function selectSlotType(i, type) { setupSlots[i].type = type; renderSetupSlots(); }
function addSetupSlot() { setupSlots.push({ type: null }); renderSetupSlots(); }
function removeSetupSlot(i) { setupSlots.splice(i, 1); renderSetupSlots(); }

function startConstructor() {
  if (setupSlots.some(s => !s.type)) { showToast('Оберіть тип для кожної фігурки!', 'danger'); return; }
  STATE.figures = setupSlots.map(s => newFigure(s.type));
  STATE.currentIdx = 0;
  STATE._freshStart = true;
  hideOverlay('overlaySetup');
  launchConstructor();
}

// ============================================================
// РОЗМІР КАРТИНОК
// Оригінали спрайтів — 2500×3084. У пам'яті кожен займає ~31 МБ,
// хоча на екрані показується завширшки 60–300 пікселів. Саме через це
// Safari на iPhone убивав вкладку («Повторення проблеми»).
// Shopify вміє віддавати зменшену копію просто за параметром в адресі,
// тому просимо рівно той розмір, який реально потрібен.
// ============================================================
// Один розмір для всіх плиток — так попереднє завантаження покриває їх усі,
// і при перемальовуванні сітки картинки беруться з кеша без миготіння.
// tileZoom навмисно дорівнює figure: плитки з наближенням беруть ту саму
// картинку, що й шари фігурки, тобто вже завантажену — без зайвих запитів.
const SPX = { tile:400, tileZoom:900, figure:900 };
function spx(url, w) {
  if (!url || !w) return url;
  // чіпаємо лише картинки з CDN Shopify — сторонні лишаємо як є
  if (url.indexOf('cdn.shopify.com') < 0 && url.indexOf('/cdn/shop/') < 0) return url;
  if (/[?&]width=/.test(url)) return url;
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}

// ===== LAUNCH =====
function getAllSpriteUrls() {
  const SM = window.SPRITE_MAP || {};
  const urls = new Set();
  function collect(obj) {
    if (!obj) return;
    if (typeof obj === 'string' && obj.startsWith('http')) { urls.add(obj); return; }
    if (typeof obj === 'object') Object.values(obj).forEach(collect);
  }
  collect(SM);
  // Готові тіла й картинка на картці лежать окремо від SPRITE_MAP, але
  // показуються так само — без прогріву їх видно, як вони «доїжджають».
  (window.READY_FIGS || []).forEach(r => { collect(r.front); collect(r.back); });
  collect(window.READY_PREVIEW);
  return [...urls];
}

// Тихо догружає решту спрайтів у фоні, вже після відкриття конструктора.
// Обидва розміри: 400 для плиток вибору, 900 для шарів фігурки — саме ті
// адреси, які потім і просить сторінка. Інакше виходить, що прогріваємо
// одне, а показуємо інше, і кожне перемикання чекає на нову картинку.
function preloadRest() {
  if (window._mbRestDone) return;
  window._mbRestDone = true;
  const targets = [];
  // Тваринки для фону рамки редактор просить у 600 px — прогріваємо саме стільки
  Object.values(window.ANIMAL_FRAME || {}).forEach(a => {
    if (a && a.url) targets.push(spx(a.url, 600));
  });
  getAllSpriteUrls().forEach(u => {
    targets.push(spx(u, SPX.tile));
    targets.push(spx(u, SPX.figure));
  });
  let i = 0;
  const lane = () => {
    if (i >= targets.length) return;
    const img = new Image();
    img.onload = img.onerror = () => { img.onload = img.onerror = null; lane(); };
    img.src = targets[i++];
  };
  // вужче, ніж при старті: це фон, він не має заважати кліками
  const LANES = (window.innerWidth <= 768) ? 4 : 8;
  for (let k = 0; k < LANES; k++) lane();
}

function preloadSprites(onDone) {
  // Чекаємо тільки на шари поточної фігурки — це десяток картинок замість
  // п'ятисот. Раніше перший запуск тривав до півхвилини, бо конструктор
  // не показувався, поки не завантажиться геть усе.
  const figs = (window.STATE || {}).figures || [];
  const need = new Set();
  figs.slice(0, 2).forEach(f => {
    try { (getFigureLayerUrls(f) || []).forEach(u => { if (u) need.add(spx(u, SPX.figure)); }); }
    catch (e) {}
  });
  const urls = [...need];
  // решту доганяємо у фоні, коли людина вже щось робить
  setTimeout(preloadRest, 1200);
  if (!urls.length) { onDone(); return; }

  // Показуємо лоадер
  const loader = document.createElement('div');
  loader.id = 'spriteLoader';
  loader.innerHTML = `
    <div style="position:fixed;inset:0;background:rgba(14,20,34,0.95);z-index:9999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px">
      <div style="font-family:'Nunito',sans-serif;color:#edd05c;font-size:18px;font-weight:800">🧱 Завантажуємо конструктор...</div>
      <div style="width:260px;height:10px;background:#1B2433;border-radius:99px;border:2px solid #000;overflow:hidden">
        <div id="spriteLoaderBar" style="height:100%;width:0%;background:#edd05c;border-radius:99px;transition:width .2s ease"></div>
      </div>
      <div id="spriteLoaderPct" style="font-family:'Nunito',sans-serif;color:#8A97B0;font-size:13px">0%</div>
    </div>`;
  document.body.appendChild(loader);

  let loaded = 0, next = 0, finished = false;
  const bar = document.getElementById('spriteLoaderBar');
  const pct = document.getElementById('spriteLoaderPct');
  // Паралельно вантажимо обмежену кількість — інакше мобільний браузер
  // відкриває сотні зʼєднань одночасно і вкладку перезапускає по памʼяті.
  const CONCURRENCY = (window.innerWidth <= 768) ? 6 : 12;

  const finish = () => {
    if (finished) return; finished = true;
    setTimeout(() => { loader.remove(); onDone(); }, 200);
  };
  const step = () => {
    loaded++;
    const p = Math.round(loaded / urls.length * 100);
    if (bar) bar.style.width = p + '%';
    if (pct) pct.textContent = p + '%';
    if (loaded >= urls.length) finish(); else pump();
  };
  const pump = () => {
    if (next >= urls.length) return;
    const url = urls[next++];
    const img = new Image();
    let settled = false;
    const on = () => { if (settled) return; settled = true; img.onload = img.onerror = null; step(); };
    img.onload = img.onerror = on;
    img.src = url;
    // якщо картинка зависла — не блокуємо весь конструктор
    setTimeout(on, 15000);
  };
  // страховка: навіть якщо частина спрайтів не відповіла — стартуємо через 25 с
  setTimeout(finish, 25000);
  for (let i = 0; i < Math.min(CONCURRENCY, urls.length); i++) pump();
}

function launchConstructor() {
  STATE._accBackShown = false;
  preloadSprites(() => {
    document.getElementById('constructor').classList.add('active');
    updateStageLabel();
    updateSidebarForFigure();
    renderFigBar();
    setNav(stepsFor()[0].id);
    updatePrices();
    renderFigureSvg();
    const fresh = !!STATE._freshStart;
    STATE._freshStart = false;
    showSwipeHint(fresh);
  });
}

// Дві незалежні підказки: горизонтальна та вертикальна.
// Кожна зникає, коли користувач зробив саме цей жест, або через 5 секунд.
function showSwipeHint(forceShow) {
  if (window.innerWidth > 768) return;
  // сховище може бути переповнене або вимкнене — це не привід ламати запуск
  try {
    if (!forceShow && localStorage.getItem('mb_swipe_hint_seen')) return;
    localStorage.setItem('mb_swipe_hint_seen', '1');
  } catch (e) {}
  setTimeout(() => { makeSwipeHint('h'); makeSwipeHint('v'); }, 300);
}
function makeSwipeHint(axis) {
  const panel = document.getElementById('rightPanel');
  const id = 'swipeHint-' + axis;
  if (!panel || document.getElementById(id)) return;

  // горизонтальна підказка накладається на смугу етапів, вертикальна — на список опцій
  const bar = document.getElementById('stepBar');
  const barH = bar ? bar.offsetHeight : 44;
  const navH = (document.querySelector('.step-nav') || {}).offsetHeight || 56;

  const hint = document.createElement('div');
  hint.id = id;
  hint.className = 'swipe-hint swipe-hint-' + axis;
  if (axis === 'h') { hint.style.top = '0'; hint.style.height = barH + 'px'; }
  else { hint.style.top = barH + 'px'; hint.style.bottom = navH + 'px'; }
  // шеврони ліворуч/праворуч (або вгору/вниз) + рука посередині
  const chev = (dir) => {
    const paths = {
      left:  'M18 4 L6 14 L18 24',  right: 'M6 4 L18 14 L6 24',
      up:    'M4 18 L14 6 L24 18',  down:  'M4 6 L14 18 L24 6',
    }[dir];
    return `<svg width="28" height="28" viewBox="0 0 28 28">
      <path class="sh-chev c1" d="${paths}"/></svg>`;
  };
  const trio = d => `<div style="display:flex;${axis==='v'?'flex-direction:column;':''}gap:0">${
    [1,2,3].map(n => chev(d).replace('c1','c'+n)).join('')}</div>`;
  hint.innerHTML = axis === 'h'
    ? `${trio('left')}<div class="sh-hand h">🖐️</div>${trio('right')}`
    : `${trio('up')}<div class="sh-hand v">🖐️</div>${trio('down')}`;
  // position панелі не міняємо — на мобільному вона позиціонована розкладкою,
  // а підміна на relative зсуває її з місця
  if (getComputedStyle(panel).position === 'static') panel.style.position = 'relative';
  panel.appendChild(hint);

  let sx = 0, sy = 0, done = false;
  const kill = () => {
    if (done) return; done = true;
    clearTimeout(timer);
    panel.removeEventListener('touchstart', onStart);
    panel.removeEventListener('touchend', onEnd);
    hint.classList.add('gone');
    setTimeout(() => hint.remove(), 260);
  };
  const onStart = e => { const t = e.touches[0]; sx = t.clientX; sy = t.clientY; };
  const onEnd = e => {
    const t = e.changedTouches[0];
    const dx = Math.abs(t.clientX - sx), dy = Math.abs(t.clientY - sy);
    if (axis === 'h' && dx > 30 && dx > dy) kill();
    if (axis === 'v' && dy > 30 && dy > dx) kill();
  };
  panel.addEventListener('touchstart', onStart, { passive: true });
  panel.addEventListener('touchend', onEnd, { passive: true });
  const timer = setTimeout(kill, 5000);
  hint.addEventListener('click', kill);
}

function updateSidebarForFigure() {
  const fig = STATE.figures[STATE.currentIdx];
  if (!fig) return;
  const isHuman = fig.type === 'human';
  const isAnimal = fig.type === 'animal';
  const isReady = fig.type === 'ready';
  // У готової фігурки тіло вже зібране — торс, принт і ноги міняти нічого
  const readyNavs = ['skin','hair','accessories'];
  ['skin','hair','torso','print','legs','accessories'].forEach(id => {
    const navEl = document.getElementById('nav-' + id);
    if (navEl) navEl.style.display = (isHuman || (isReady && readyNavs.includes(id))) ? '' : 'none';
  });
  const navReady = document.getElementById('nav-ready');
  if (navReady) navReady.style.display = isReady ? '' : 'none';
  const skinTxt = document.querySelector('#nav-skin .nav-item-text');
  if (skinTxt) skinTxt.textContent = isReady ? 'Обличчя' : 'Шкіра та Обличчя';
  document.getElementById('nav-animal').style.display = isAnimal ? '' : 'none';
  const navItem = document.getElementById('nav-item');
  if (navItem) navItem.style.display = (fig.type === 'item') ? '' : 'none';
  const frameOff = window.FRAME_MODE ? 'none' : '';
  document.getElementById('nav-keychain').style.display = frameOff;
  document.getElementById('nav-addons').style.display = frameOff;
  // Покраска за фото — і в рамці теж, тваринку красять однаково
  document.getElementById('nav-extra').style.display = isAnimal ? '' : 'none';
  // Упаковка прихована (nav-package має display:none у розмітці)
  const ok = stepsFor().filter(s => !s.dis).map(s => s.id);
  if (!ok.includes(STATE.currentNav)) STATE.currentNav = ok[0];
}

function updateStageLabel() {
  const f = STATE.figures[STATE.currentIdx];
  if (!f) return;
  const lbl = document.getElementById('stageFigLabel');
  if (!lbl) return;
  const nm = f.type === 'human' ? 'Фігурка' : (FIG_NAMES[f.type] || 'Тваринка');
  lbl.textContent = `${nm} ${STATE.currentIdx + 1}`;
}

// ============================================================
// РЕЖИМ РАМКИ — конструктор як шар усередині редактора рамок
// ============================================================
const FRAME_STEPS_HUMAN = ['skin','hair','torso','print','legs','accessories'];
// Покраска за фото діє й у рамці: тваринку так само можна замовити схожою
// на справжнього улюбленця. Поки послуга вимкнена — крок видно, але він
// не активний (CUSTOM_PAINT_OFF).
const FRAME_STEPS_ANIMAL = ['animal', 'extra'];
const FRAME_STEPS_ITEM   = ['item'];
const STEPS_ITEM = [{ id:'item', n:'Предмет' }];
// Готове тіло вже зібране — лишається обличчя, зачіска й аксесуари
const STEPS_READY = [
  { id:'ready',       n:'Готова фігурка' },
  { id:'skin',        n:'Обличчя' },
  { id:'hair',        n:'Зачіска' },
  { id:'accessories', n:'Аксесуари' },
];
window.FRAME_MODE = false;
window.FRAME_MAX = 99;
let _frameDone = null;   // callback: (figures[]) => void

// У рамці немає брелка, серця, підставки та покраски
function sanitizeForFrame(fig) {
  const f = Object.assign(newFigure('human'), JSON.parse(JSON.stringify(fig || {})));
  // Брелок, серце й підставка до рамки не йдуть — це окремі товари.
  // А от покраску за фото лишаємо: у рамці вона така сама послуга.
  f.keychain = false; f.heartKeychain = false; f.stand = false;
  return f;
}
// Викликає редактор рамок. figs — наявні фігурки рамки, startIdx — яку відкрити.
function openFrameBuilder(figs, max, startIdx, onDone, askType) {
  window.FRAME_MODE = true;
  window.FRAME_MAX = max || 99;
  _frameDone = onDone || null;
  let list = (figs && figs.length) ? figs.map(sanitizeForFrame) : [sanitizeForFrame(null)];
  let idx = Math.min(Math.max(startIdx || 0, 0), list.length - 1);

  // Якщо минулого разу сайт вилетів посеред збирання — підхоплюємо роботу.
  // Чернетка належить саме цьому набору фігурок (звіряємо підпис),
  // інакше її ігноруємо, щоб не підставити чужу фігурку в іншу рамку.
  const baseSig = frameSig(list);
  window._frameBaseSig = baseSig;
  try {
    const raw = localStorage.getItem(FRAME_WIP_KEY);
    const w = raw ? JSON.parse(raw) : null;
    if (w && w.baseSig === baseSig && Array.isArray(w.figures) && w.figures.length &&
        Date.now() - (w.at || 0) < 12 * 3600 * 1000 && frameSig(w.figures) !== baseSig) {
      list = w.figures.map(sanitizeForFrame);
      idx = Math.min(Math.max(w.currentIdx || 0, 0), list.length - 1);
      setTimeout(() => showToast('Відновлено незавершену фігурку'), 400);
    }
  } catch (e) {}

  STATE.figures = list;
  STATE.currentIdx = idx;
  STATE._freshStart = false;
  document.body.classList.add('frame-mode');
  launchConstructor();
  // Прийшли з кнопки «Зібрати фігурку» — одразу питаємо, кого збираємо.
  // askType === 'first' означає, що набір був порожній: вибір типу має
  // замінити порожню заготовку, а не додати до неї другу фігурку.
  STATE._replaceFirst = (askType === 'first');
  if (askType) setTimeout(() => showOverlay('overlayAddChar'), 250);
}
function closeFrameBuilder() {
  window.FRAME_MODE = false;
  _frameDone = null;
  clearFrameWip();   // роботу або віддано в рамку, або свідомо скасовано
  document.body.classList.remove('frame-mode');
  document.getElementById('constructor').classList.remove('active');
}
// «Готово — у рамку»: повертаємо всі зібрані фігурки
function frameBuilderDone() {
  const cb = _frameDone;
  const all = STATE.figures.map(f => JSON.parse(JSON.stringify(f)));
  closeFrameBuilder();
  if (cb) cb(all);
}

// ============================================================
// ЕТАПИ СКЛАДАННЯ
// ============================================================
const STEPS_HUMAN = [
  { id:'skin',        n:'Шкіра та обличчя' },
  { id:'hair',        n:'Зачіска' },
  { id:'torso',       n:'Торс' },
  { id:'print',       n:'Принт' },
  { id:'legs',        n:'Ноги' },
  { id:'accessories', n:'Аксесуари' },
  { id:'keychain',    n:'Брелок' },
  { id:'addons',      n:'Доп. деталі' },
];
const STEPS_ANIMAL = [
  { id:'animal',   n:'Тваринка' },
  { id:'keychain', n:'Брелок' },
  { id:'addons',   n:'Доп. деталі' },
  { id:'extra',    n:'Кастом', dis:true },   // покраска за фото — тимчасово вимкнено
];
function stepsFor() {
  const f = STATE.figures[STATE.currentIdx];
  if (f && f.type === 'item') return STEPS_ITEM;   // предмет обирають одним кроком
  if (f && f.type === 'ready') return STEPS_READY;
  const all = (f && f.type === 'animal') ? STEPS_ANIMAL : STEPS_HUMAN;
  if (!window.FRAME_MODE) return all;
  // у рамці немає брелка, лего-серця й підставки
  const keep = (f && f.type === 'animal') ? FRAME_STEPS_ANIMAL : FRAME_STEPS_HUMAN;
  return all.filter(s => keep.includes(s.id));
}
function stepIndex() {
  const s = stepsFor().findIndex(x => x.id === STATE.currentNav);
  return s < 0 ? 0 : s;
}
function lastActiveStep() {
  const steps = stepsFor();
  for (let i = steps.length - 1; i >= 0; i--) if (!steps[i].dis) return i;
  return 0;
}
function renderSteps() {
  const bar = document.getElementById('stepBar');
  if (!bar) return;
  const steps = stepsFor(), cur = stepIndex();
  bar.innerHTML = steps.map((s, i) => {
    const cls = s.dis ? 'off' : (i === cur ? 'cur' : (i < cur ? 'done' : 'future'));
    const click = (!s.dis && i <= cur) ? `setNav('${s.id}')` : '';
    return `<div class="step ${cls}"${s.dis ? ' title="Тимчасово недоступно"' : ''} onclick="${click}">
      <span class="step-num">${String(i+1).padStart(2,'0')}</span>
      <span class="step-name">${s.n}</span>
    </div>${i < steps.length-1 ? '<i class="step-line"></i>' : ''}`;
  }).join('');
  const t = document.getElementById('stepTitle');
  // на компʼютері прогрес-бар етапів прихований — лишаємо загальну назву
  if (t) t.textContent = (window.innerWidth > 900)
    ? 'Кастом опції'
    : (steps[cur] ? steps[cur].n : 'Кастом опції');
  // прокручуємо активний етап у видиму зону
  const el = bar.querySelector('.step.cur');
  if (el) el.scrollIntoView({ inline:'center', block:'nearest', behavior:'smooth' });
  updateStepNav();
}
function updateStepNav() {
  const steps = stepsFor(), cur = stepIndex();
  const back = document.getElementById('stepBack');
  const next = document.getElementById('stepNext');
  const cart = document.getElementById('btnAddCart');
  if (!back || !next || !cart) return;

  const isLastStep = cur >= lastActiveStep();
  const isLastFig  = STATE.currentIdx === STATE.figures.length - 1;
  back.disabled = cur === 0 && STATE.currentIdx === 0;

  if (window.FRAME_MODE) {
    cart.textContent = STATE.figures.length > 1 ? '✓ Готово — у рамку' : '✓ Додати в рамку';
    cart.onclick = frameBuilderDone;
  } else {
    cart.textContent = 'Додати в кошик';
    cart.onclick = openCart;
  }

  if (isLastStep && isLastFig) {
    next.style.display = 'none'; cart.style.display = '';
  } else {
    next.style.display = ''; cart.style.display = 'none';
    next.textContent = isLastStep
      ? `До ${FIG_NAMES_GEN[STATE.figures[STATE.currentIdx+1].type] || 'фігурки'} ${STATE.currentIdx+2} →`
      : 'Далі →';
  }
}
function stepNext() {
  const steps = stepsFor(), cur = stepIndex();
  for (let i = cur + 1; i < steps.length; i++) if (!steps[i].dis) { setNav(steps[i].id); return; }
  if (STATE.currentIdx < STATE.figures.length - 1) switchFigure(STATE.currentIdx + 1);
}
function stepPrev() {
  const steps = stepsFor(), cur = stepIndex();
  for (let i = cur - 1; i >= 0; i--) if (!steps[i].dis) { setNav(steps[i].id); return; }
  if (STATE.currentIdx > 0) {
    switchFigure(STATE.currentIdx - 1);
    setNav(stepsFor()[lastActiveStep()].id);   // на останній етап попередньої фігурки
  }
}

// ============================================================
// СМУГА ФІГУРОК
// ============================================================
function renderFigBar() {
  const bar = document.getElementById('figBar');
  if (!bar) return;
  const atMax = window.FRAME_MODE && STATE.figures.length >= window.FRAME_MAX;
  bar.innerHTML = STATE.figures.map((f, i) => `
    <div class="fig-chip ${i === STATE.currentIdx ? 'active' : ''}" onclick="switchFigure(${i})">
      <div class="fig-chip-img" id="figchip-${i}">${FIG_ICONS[f.type] || '🐾'}</div>
      <span>${FIG_NAMES[f.type] || 'Фігурка'} ${i+1}</span>
    </div>`).join('') +
    (atMax
      ? `<div class="fig-chip add full" title="Ліміт фігурок для цієї рамки">
          <div class="fig-chip-img">✓</div><span>Ліміт ${window.FRAME_MAX}</span></div>`
      : `<div class="fig-chip add" onclick="showOverlay('overlayAddChar')">
          <div class="fig-chip-img">＋</div><span>Додати</span></div>`);
  fillFigChips();
}
async function fillFigChips(onlyIdx) {
  for (let i = 0; i < STATE.figures.length; i++) {
    if (onlyIdx != null && i !== onlyIdx) continue;
    const el = document.getElementById('figchip-' + i);
    if (!el) continue;
    const url = await composeFigureThumb(STATE.figures[i]);
    const still = document.getElementById('figchip-' + i);
    if (url && still) still.innerHTML = `<img src="${url}">`;
  }
}

// Маленьке превʼю фігурки. Свідомо рендеримо в низькій роздільності
// і обмежуємо кеш — інакше на мобільних браузер вбиває вкладку по памʼяті.
const THUMB_W = 128, THUMB_H = 157, THUMB_CACHE_MAX = 40;
const FIG_THUMB_CACHE = new Map();
let _thumbCanvas = null;
function composeFigureThumb(fig) {
  const urls = getFigureLayerUrls(fig).filter(Boolean);
  const key = urls.join('|');
  if (!key) return Promise.resolve(null);
  if (FIG_THUMB_CACHE.has(key)) return Promise.resolve(FIG_THUMB_CACHE.get(key));
  return new Promise(resolve => {
    if (!_thumbCanvas) {                       // один спільний canvas на всі превʼю
      _thumbCanvas = document.createElement('canvas');
      _thumbCanvas.width = THUMB_W; _thumbCanvas.height = THUMB_H;
    }
    const ctx = _thumbCanvas.getContext('2d');
    ctx.clearRect(0, 0, THUMB_W, THUMB_H);
    let loaded = 0; const imgs = urls.map(() => null);
    const done = () => {
      imgs.forEach(x => { if (x) { try { ctx.drawImage(x, 0, 0, THUMB_W, THUMB_H); } catch (e) {} } });
      let d = null;
      try { d = _thumbCanvas.toDataURL('image/png'); } catch (e) { d = null; }
      if (d) {
        if (FIG_THUMB_CACHE.size >= THUMB_CACHE_MAX) {
          FIG_THUMB_CACHE.delete(FIG_THUMB_CACHE.keys().next().value);
        }
        FIG_THUMB_CACHE.set(key, d);
      }
      resolve(d);
    };
    const timeout = setTimeout(() => { if (loaded < urls.length) { loaded = urls.length; done(); } }, 4000);
    urls.forEach((u, i) => {
      const im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = im.onerror = () => {
        imgs[i] = (im.complete && im.naturalWidth) ? im : null;
        if (++loaded !== urls.length) return;
        clearTimeout(timeout);
        done();
      };
      im.src = spx(u, SPX.tile);
    });
  });
}
// Превʼю за замовчуванням для діалогів вибору типу
function defaultPreview(type, elId) {
  if (type === 'animal') {
    const url = ((window.SPRITE_MAP || {}).animals || {})[2];
    const el = document.getElementById(elId);
    if (url && el) el.innerHTML = `<img src="${spx(url, SPX.tile)}" alt="">`;
    return;
  }
  composeFigureThumb(newFigure('human')).then(url => {
    const el = document.getElementById(elId);
    if (url && el) el.innerHTML = `<img src="${url}" alt="">`;
  });
}
let _readyPrevTrim = null;   // обрізане превʼю картки — ріжемо раз за сеанс
function fillTypePreviews() {
  defaultPreview('human',  'prevHuman');
  defaultPreview('animal', 'prevAnimal');
  // картка «Готова фігурка» — спільне превʼю обох тіл, обрізане по краях,
  // інакше картинка губиться серед порожнього поля
  const rb = document.getElementById('prevReady');
  const rprev = window.READY_PREVIEW || ((window.READY_FIGS || [])[0] || {}).front;
  if (rb && rprev) {
    if (_readyPrevTrim) {
      rb.innerHTML = '<img src="' + _readyPrevTrim + '" alt="">';
    } else {
      // беремо той самий розмір, що прогрівається у фоні (SPX.tile),
      // інакше браузер тягне ще одну копію картинки з нуля
      trimImage(rprev, SPX.tile).then(u => {
        _readyPrevTrim = u;
        const still = document.getElementById('prevReady');
        if (u && still) still.innerHTML = '<img src="' + u + '" alt="">';
      });
    }
  }
  // картка «Інше» — показуємо справжній предмет, а не значок
  const box = document.getElementById('prevItem');
  const lib = window.FE_ITEM_LIB || [];
  if (box && lib.length) {
    const first = lib.find(x => !x.soon) || lib[0];
    if (first) box.innerHTML = '<img src="' + spx(first.url, 220) + '" alt="">';
  }
}

// Додати персонажа з діалогу
// Закрили вибір без відповіді — заготовка лишається людиною, як і було
function cancelAddChar() {
  STATE._replaceFirst = false;
  hideOverlay('overlayAddChar');
}
function addCharacter(type) {
  hideOverlay('overlayAddChar');
  // Перший вибір у порожньому наборі — переробляємо заготовку, а не додаємо
  if (STATE._replaceFirst && STATE.figures.length === 1) {
    STATE._replaceFirst = false;
    const nu = newFigure(type);
    if (type === 'item') {
      const first = (window.FE_ITEM_LIB || []).find(x => x && !x.soon);
      if (first) nu.itemId = first.id;
    }
    STATE.figures[0] = nu;
    switchFigure(0);
    saveState();
    return;
  }
  STATE._replaceFirst = false;
  addFigFromPanel(type);
}

function updateNavButtons() { updateStepNav(); }

function nextFigure() { switchFigure(STATE.currentIdx + 1); }

function switchFigure(i) {
  STATE.currentIdx = i;
  updateStageLabel();
  updateSidebarForFigure();
  renderFigBar();
  setNav(stepsFor()[0].id);   // нова фігурка — починаємо з першого етапу
  updatePrices();
  renderFigureSvg();
}

function deleteCurrent() {
  if (STATE.figures.length <= 1) { showToast('Не можна видалити останню фігурку', 'danger'); return; }
  STATE.figures.splice(STATE.currentIdx, 1);
  if (STATE.currentIdx >= STATE.figures.length) STATE.currentIdx = STATE.figures.length - 1;
  updateStageLabel(); updateSidebarForFigure(); renderFigBar();
  setNav(stepsFor()[0].id);
  updatePrices(); renderFigureSvg();
}

function setNav(nav) {
  STATE.currentNav = nav;
  document.querySelectorAll('.nav-item').forEach(el => el.classList.remove('active'));
  const el = document.getElementById('nav-' + nav);
  if (el) el.classList.add('active');
  renderRightPanel();
  renderSteps();
  // панель тепер завжди відкрита
  document.getElementById('rightPanel').classList.add('open');
  document.getElementById('constructor').classList.add('panel-open');
}

// лишились для сумісності зі старими викликами
function openCustomize() { setNav(STATE.currentNav); }
function closeOptionsPanel() {}

// Підпис кнопки = те, що станеться після натискання. Дивимось спереду —
// кнопка пропонує «Вигляд ззаду», і навпаки.
function updateRotateBtn() {
  const b = document.getElementById('rotateBtn');
  if (!b) return;
  const fig = STATE.figures[STATE.currentIdx];
  b.textContent = (fig && fig.facing === 'back') ? '↺ Вигляд спереду' : '↺ Вигляд ззаду';
}

function rotateFig() {
  const fig = STATE.figures[STATE.currentIdx];
  fig.facing = fig.facing === 'front' ? 'back' : 'front';
  if (fig.facing === 'back' && !STATE._accBackShown) {
    STATE._accBackShown = true;
    showOverlay('overlayAccBack');
  }
  renderFigureSvg(); saveState();
  showToast(fig.facing === 'back' ? 'Вигляд ззаду' : 'Вигляд спереду');
}

// ===== RIGHT PANEL =====
function renderRightPanel() {
  const body = document.getElementById('rightPanelBody');
  const savedScroll = body.scrollTop;
  const fig = STATE.figures[STATE.currentIdx];
  if (!fig) { body.innerHTML = ''; return; }
  const nav = STATE.currentNav;
  if      (nav === 'figures')     body.innerHTML = renderFiguresPanel();
  else if (nav === 'animal')      body.innerHTML = renderAnimalPanel(fig);
  else if (nav === 'item')        body.innerHTML = renderItemPanel(fig);
  else if (nav === 'ready')       body.innerHTML = renderReadyPanel(fig);
  else if (nav === 'skin')        body.innerHTML = renderSkinPanel(fig);
  else if (nav === 'hair')        body.innerHTML = renderHairPanel(fig);
  else if (nav === 'torso')       body.innerHTML = renderTorsoPanel(fig);
  else if (nav === 'print')       body.innerHTML = renderPrintPanel(fig);
  else if (nav === 'legs')        body.innerHTML = renderLegsPanel(fig);
  else if (nav === 'accessories') body.innerHTML = renderAccessoriesPanel(fig);
  else if (nav === 'keychain')    body.innerHTML = renderKeychainPanel(fig);
  else if (nav === 'package')     body.innerHTML = renderPackagePanel(fig);
  else if (nav === 'extra')       body.innerHTML = renderExtraPanel(fig);
  else if (nav === 'addons')      body.innerHTML = renderAddonsPanel(fig);
  else body.innerHTML = '';

  const uz = document.getElementById('uploadZone');
  if (uz) uz.onclick = tryUploadPhoto;
  if (nav === 'extra' && fig.customPaint) renderPhotosList();
  // Відновлюємо позицію скролу (щоб панель не стрибала при перевиборі)
  body.scrollTop = savedScroll;
}

// ===== FIGURES PANEL =====
let showAddTypeChoice = false;
function renderFiguresPanel() {
  let html = '<div class="co-section"><div class="co-section-title">🧩 Персонажі в наборі</div>';
  STATE.figures.forEach((f, i) => {
    const active = i === STATE.currentIdx;
    html += `<div class="fig-panel-item ${active?'active':''}" onclick="switchFigure(${i})">
      <span style="font-size:18px">${FIG_ICONS[f.type]}</span>
      <div style="flex:1"><div style="font-size:12px;font-weight:600">${FIG_NAMES[f.type]} ${i+1}</div><div style="font-size:10px;color:var(--text-muted)">${figurePrice(f)} грн</div></div>
      ${STATE.figures.length>1 ? `<span onclick="event.stopPropagation();deleteFigureFromPanel(${i})" style="color:var(--danger);font-size:14px;cursor:pointer;padding:4px 2px">✕</span>` : ''}
    </div>`;
  });
  html += `<div class="fig-panel-add" onclick="toggleAddChoice()">＋ Додати фігурку або тваринку</div>`;
  if (showAddTypeChoice) {
    html += `<div class="type-choice-row">
      <div class="type-choice-btn" onclick="addFigFromPanel('human')"><span>🧍</span><strong>Людина</strong><em>від 120 грн</em></div>
      <div class="type-choice-btn" onclick="addFigFromPanel('animal')"><span>🐾</span><strong>Тваринка</strong><em>від 50 грн</em></div>
      ${window.FRAME_MODE ? `<div class="type-choice-btn" onclick="addFigFromPanel('ready')"><span>👔</span><strong>Готова</strong><em>від 120 грн</em></div>` : ''}
    </div>`;
  }
  html += '</div>';
  return html;
}
function toggleAddChoice() { showAddTypeChoice = !showAddTypeChoice; renderRightPanel(); }
function addFigFromPanel(type) {
  if (window.FRAME_MODE && STATE.figures.length >= window.FRAME_MAX) {
    showToast(`Для цієї рамки максимум ${window.FRAME_MAX} фігурок`, 'danger');
    return;
  }
  const nu = newFigure(type);
  // «Інше» без обраного предмета — це порожнє місце на полотні. Ставимо
  // перший доступний, щоб людина одразу бачила, про що йдеться, і далі
  // просто перемикала на потрібний.
  if (type === 'item') {
    const first = (window.FE_ITEM_LIB || []).find(x => x && !x.soon);
    if (first) nu.itemId = first.id;
  }
  STATE.figures.push(nu);
  showAddTypeChoice = false;
  switchFigure(STATE.figures.length - 1);
  showToast(`${FIG_NAMES[type]} додано!`, 'success');
  saveState();
}
function deleteFigureFromPanel(i) {
  if (STATE.figures.length <= 1) { showToast('Не можна видалити останню фігурку', 'danger'); return; }
  STATE.figures.splice(i, 1);
  if (STATE.currentIdx >= STATE.figures.length) STATE.currentIdx = STATE.figures.length - 1;
  updateStageLabel(); updateSidebarForFigure(); renderFigBar();
  setNav(stepsFor()[0].id); updatePrices(); renderFigureSvg();
  saveState();
}

// ===== ANIMAL PANEL =====
const ANIMAL_PAGE_SIZE = (window.innerWidth <= 768) ? 5 : 10;
let _animalPage = 0;
function setAnimalPage(page) { _animalPage = page; renderRightPanel(); }

function renderAnimalPanel(fig) {
  const SM = window.SPRITE_MAP || {};
  const animalSprites = SM.animals || {};
  const total = ANIMALS.length;
  const totalPages = Math.max(1, Math.ceil(total / ANIMAL_PAGE_SIZE));
  const page = Math.min(_animalPage, totalPages - 1);
  const pageAnimals = ANIMALS.slice(page * ANIMAL_PAGE_SIZE, page * ANIMAL_PAGE_SIZE + ANIMAL_PAGE_SIZE);

  let html = '<div class="co-section"><div class="co-section-title">🐾 Оберіть тваринку</div><div class="co-grid">';
  pageAnimals.forEach(a => {
    const url = animalSprites[a.id] || '';
    const oos = (window.ANIMALS_OOS || []).includes(a.id);
    html += `<div class="co-item ${fig.animalType===a.id?'selected':''} ${oos?'unavailable':''}" onclick="${oos?'showOOS()':'setAnimal('+a.id+')'}">
      ${url ? accThumb(url, 'an_'+a.id) : `<div class="co-item-img-placeholder" style="font-size:24px">${a.emoji||'🐾'}</div>`}
      <div class="co-item-label">${a.label}${oos?' ✕':''}</div>
    </div>`;
  });
  html += '</div>';
  if (totalPages > 1) {
    html += `<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;gap:8px">
      <button onclick="setAnimalPage(${page-1})" ${page===0?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===0?'#1B2433':'#252F42'};color:${page===0?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===0?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">← Назад</button>
      <span style="font-size:11px;color:var(--text-muted);white-space:nowrap">${page+1} / ${totalPages}</span>
      <button onclick="setAnimalPage(${page+1})" ${page===totalPages-1?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===totalPages-1?'#1B2433':'#252F42'};color:${page===totalPages-1?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===totalPages-1?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">Далі →</button>
    </div>`;
  }
  html += '</div>';
  return html;
}
function setAnimal(id) {
  const fig = STATE.figures[STATE.currentIdx];
  fig.animalType = id;
  renderFigureSvg(); renderRightPanel(); saveState();
  showToast('Тваринку обрано ✓', 'success');
}

// ===== SKIN =====
const FACE_PAGE_SIZE = (window.innerWidth <= 768) ? 5 : 6;
let _facePage = 0;
function setFacePage(page) { _facePage = page; renderRightPanel(); }

// Готові фігурки — вибір самого тіла. Колір і принт не міняються:
// це реальна деталь, яка або є на складі такою, або її немає.
function renderReadyPanel(fig) {
  const lib = window.READY_FIGS || [];
  if (!lib.length) {
    return '<div class="co-section"><div class="co-section-title">Готові фігурки</div>'
         + '<p style="font-size:12px;color:var(--text-dim)">Список ще не завантажено.</p></div>';
  }
  let html = '<div class="co-section"><div class="co-section-title">Оберіть готову фігурку ('
           + PRICES.ready + ' грн)</div><div class="co-grid">';
  lib.forEach(r => {
    html += '<div class="co-item ' + (fig.readyId === r.id ? 'selected' : '') + '"'
          + ' onclick="setReady(' + r.id + ')">'
          + accThumb(r.front, 'rd_' + r.id)
          + '<div class="co-item-label">' + r.label + '</div></div>';
  });
  html += '</div><p style="font-size:11px;color:var(--text-dim);margin-top:8px">'
        + 'Тіло вже зібране — далі оберіть обличчя, зачіску та аксесуари.</p></div>';
  return html;
}
function setReady(id) {
  const fig = STATE.figures[STATE.currentIdx];
  if (!fig) return;
  fig.readyId = id;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
}

function renderSkinPanel(fig) {
  // У готової фігурки голова завжди тілесна — лишається тільки обличчя
  if (fig.type === 'ready') return renderFaceSection(fig, '');
  let html = '<div class="co-section"><div class="co-section-title">1.1 Колір шкіри</div><div class="co-types">';
  SKIN_COLORS.forEach(s => {
    const oos = (SKIN_OOS || []).includes(s.id);
    if (oos) {
      html += `<div class="co-type-btn unavailable" style="opacity:.4;cursor:not-allowed;position:relative" onclick="showOOS()" title="Немає в наявності">${s.label}<span style="position:absolute;top:2px;right:4px;font-size:9px">✕</span></div>`;
    } else {
      html += `<div class="co-type-btn ${fig.skin===s.id?'selected':''}" onclick="setSkin('${s.id}','${s.color}')" style="${fig.skin===s.id?`border-color:${s.color};color:${s.color};background:${s.color}22`:''}">${s.label}</div>`;
    }
  });
  html += '</div></div>';
  return html + renderFaceSection(fig, '1.2 ');
}
// Вибір обличчя — окремо, бо готова фігурка бере тільки його
function renderFaceSection(fig, num) {
  let html = '';
  const SM = window.SPRITE_MAP || {};
  const totalFaces = FACES.length;
  const totalPages = Math.max(1, Math.ceil(totalFaces / FACE_PAGE_SIZE));
  const page = Math.min(_facePage, totalPages - 1);
  const pageFaces = FACES.slice(page * FACE_PAGE_SIZE, page * FACE_PAGE_SIZE + FACE_PAGE_SIZE);

  html += `<div class="co-section"><div class="co-section-title">${num}Обличчя</div><div class="co-grid">`;
  pageFaces.forEach(f => {
    const unavail = FACES_OOS.includes(f.id);
    const previewUrl = (SM.facePreviews || {})[f.id] || (SM.faces || {})[f.id];
    const inner = previewUrl
      ? `<div style="width:100%;aspect-ratio:1;overflow:hidden;border-radius:6px;background:#fff;position:relative"><img src="${spx(previewUrl, SPX.tileZoom)}" style="position:absolute;width:100%;height:auto;top: 30%;left:0;transform:scale(3.2);transform-origin:50% 38%" alt=""></div>`
      : `<div class="co-item-img-placeholder"><span style="font-size:22px">${f.emoji||'😊'}</span></div>`;
    html += `<div class="co-item ${fig.face===f.id?'selected':''} ${unavail?'unavailable':''}" data-face-id="${f.id}" onclick="${unavail?'showOOS()':'setFace('+f.id+')'}">
      ${inner}
      <div class="co-item-label">${f.label||'Обличчя '+(f.id+1)}</div>
    </div>`;
  });
  html += '</div>';
  if (totalPages > 1) {
    html += `<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;gap:8px">
      <button onclick="setFacePage(${page-1})" ${page===0?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===0?'#1B2433':'#252F42'};color:${page===0?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===0?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">← Назад</button>
      <span style="font-size:11px;color:var(--text-muted);white-space:nowrap">${page+1} / ${totalPages}</span>
      <button onclick="setFacePage(${page+1})" ${page===totalPages-1?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===totalPages-1?'#1B2433':'#252F42'};color:${page===totalPages-1?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===totalPages-1?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">Далі →</button>
    </div>`;
  }
  html += '</div>';
  return html;
}

// ===== HAIR =====
const HAIR_PAGE_SIZE = (window.innerWidth <= 768) ? 5 : 6;
let _hatPage = 0;
let _hairStylePage = 0;
function setHatPage(p) { _hatPage = p; renderRightPanel(); }
function setHairStylePage(p) { _hairStylePage = p; renderRightPanel(); }

// Хелпер пагінації: повертає {items, pagerHtml}
function paginate(list, page, pageSize, setterName) {
  const totalPages = Math.max(1, Math.ceil(list.length / pageSize));
  const p = Math.min(page, totalPages - 1);
  const items = list.slice(p * pageSize, p * pageSize + pageSize);
  let pagerHtml = '';
  if (totalPages > 1) {
    pagerHtml = `<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;gap:8px">
      <button onclick="${setterName}(${p-1})" ${p===0?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${p===0?'#1B2433':'#252F42'};color:${p===0?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${p===0?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">← Назад</button>
      <span style="font-size:11px;color:var(--text-muted);white-space:nowrap">${p+1} / ${totalPages}</span>
      <button onclick="${setterName}(${p+1})" ${p===totalPages-1?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${p===totalPages-1?'#1B2433':'#252F42'};color:${p===totalPages-1?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${p===totalPages-1?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">Далі →</button>
    </div>`;
  }
  return { items, pagerHtml };
}

function renderHairPanel(fig) {
  const SM = window.SPRITE_MAP || {};
  let html = '<div class="co-section"><div class="co-section-title">2.1 Тип зачіски</div><div class="co-types">';
  HAIR_TYPES.forEach(t => {
    html += `<div class="co-type-btn ${fig.hairType===t.id?'selected':''}" onclick="setHairType('${t.id}')">${t.label}</div>`;
  });
  html += '</div></div>';
  if (fig.hairType === 'hat') {
    const { items, pagerHtml } = paginate(window.HATS || [], _hatPage, HAIR_PAGE_SIZE, 'setHatPage');
    html += '<div class="co-section"><div class="co-section-title">2.2 Стиль</div><div class="co-grid">';
    items.forEach(h => {
      const unavail = (window.HATS_OOS || []).includes(h.id);
      const hatObj = (SM.hats || {})[h.id] || {};
      const preview = hatObj.back || hatObj.front;
      const hatFar = [2,3,6,9,10].includes(h.id);
      const hatZoom = hatFar ? 'transform:scale(1.8);transform-origin:50% 22%' : 'transform:scale(2.8);transform-origin:50% 18%';
      const inner = preview
        ? `<div style="width:100%;aspect-ratio:1;overflow:hidden;border-radius:6px;background:#fff;position:relative"><img src="${spx(preview, SPX.tileZoom)}" style="position:absolute;width:100%;height:auto;top:5%;left:0;${hatZoom}" alt=""></div>`
        : `<div class="co-item-img-placeholder">🎩</div>`;
      html += `<div class="co-item ${fig.hatStyle===h.id?'selected':''} ${unavail?'unavailable':''}" onclick="${unavail?'showOOS()':'setHatStyle('+h.id+')'}">
        ${inner}
        <div class="co-item-label">Убір ${h.id}</div>
      </div>`;
    });
    html += '</div>' + pagerHtml + '</div>';
  } else if (fig.hairType !== 'bald') {
    html += '<div class="co-section"><div class="co-section-title">2.2 Колір</div><div class="co-colors">';
    // Тільки кольори, що мають хоча б один стиль зі спрайтом
    const availColors = HAIR_COLORS.filter(c => HAIR_STYLES.some(s => ((SM.hair || {})[`${s.id}_${c}`] || {}).front));
    availColors.forEach(c => {
      html += `<div class="color-swatch ${fig.hairColor===c?'selected':''}" style="background:${c}" onclick="setHairColor('${c}')"></div>`;
    });
    html += '</div></div>';
    // Показуємо тільки стилі, що мають спрайт у вибраному кольорі
    const availStyles = HAIR_STYLES.filter(s => ((SM.hair || {})[`${s.id}_${fig.hairColor}`] || {}).front);
    const { items, pagerHtml } = paginate(availStyles, _hairStylePage, HAIR_PAGE_SIZE, 'setHairStylePage');
    html += '<div class="co-section"><div class="co-section-title">2.3 Стиль</div><div class="co-grid">';
    items.forEach(s => {
      const unavail = HAIR_STYLES_OOS.includes(s.id);
      const hw = (SM.hair || {})[`${s.id}_${fig.hairColor}`] || {};
      const preview = hw.back || hw.front;
      // Довгі зачіски — менший зум, щоб влазили повністю
      let scale = 2, origin = '50% 25%';
      if ([17,19,20,21,26,37].includes(s.id))          { scale = 1.25; origin = '50% 32%'; }
      else if ([12,23,27,30,32,36,38].includes(s.id))  { scale = 1.5;  origin = '50% 30%'; }
      else if (s.id === 24)                            { scale = 1.75; origin = '50% 28%'; }
      const zoom = `transform:scale(${scale});transform-origin:${origin}`;
      const inner = preview
        ? `<div style="width:100%;aspect-ratio:1;overflow:hidden;border-radius:6px;background:#fff;position:relative"><img src="${spx(preview, SPX.tileZoom)}" style="position:absolute;width:100%;height:auto;top:5%;left:0;${zoom}" alt=""></div>`
        : `<div class="co-item-img-placeholder">${s.emoji||'💇'}</div>`;
      html += `<div class="co-item ${fig.hairStyle===s.id?'selected':''} ${unavail?'unavailable':''}" onclick="${unavail?'showOOS()':'setHairStyle('+s.id+')'}">
        ${inner}
        <div class="co-item-label">Стиль ${s.id}</div>
      </div>`;
    });
    html += '</div>' + pagerHtml + '</div>';
  }
  return html;
}

// ===== TORSO =====
function renderTorsoPanel(fig) {
  const SM = window.SPRITE_MAP || {};
  const availTorso = Object.keys(SM.torso||{}).filter(k => (SM.torso||{})[k]);
  const availArms  = Object.keys(SM.arms ||{}).filter(k => (SM.arms ||{})[k]);

  function colorStyle(key) {
    if (key === 'flesh') return 'background:#F5CC7F';
    return `background:${key}${key==='#fff'?';border:1px solid rgba(255,255,255,0.2)':''}`;
  }

  let html = '<div class="co-section"><div class="co-section-title">3.1 Колір торсу</div><div class="co-colors">';
  availTorso.forEach(c => {
    html += `<div class="color-swatch ${fig.torsoColor===c?'selected':''}" style="${colorStyle(c)}" onclick="setTorsoColor('${c}')"></div>`;
  });
  html += '</div></div>';
  html += '<div class="co-section"><div class="co-section-title">3.2 Колір рукавів</div><div class="co-colors">';
  availArms.forEach(c => {
    html += `<div class="color-swatch ${fig.sleeveColor===c?'selected':''}" style="${colorStyle(c)}" onclick="setSleeveColor('${c}')"></div>`;
  });
  html += '</div></div>';
  return html;
}

const PRINT_PAGE_SIZE = (window.innerWidth <= 768) ? 5 : 10;
let _printPage = 0;
function setPrintPage(p) { _printPage = p; renderRightPanel(); }

function renderPrintPanel(fig) {
  const SM = window.SPRITE_MAP || {};
  let html = '<div class="co-section"><div class="co-section-title">4.1 Принт (+30 грн)</div><div class="co-pills">';
  PRINT_CATS.forEach(cat => {
    html += `<div class="co-pill ${fig.printCat===cat?'selected':''}" onclick="setPrintCat('${cat}')">${cat}</div>`;
  });
  html += '</div>';
  if (fig.printCat && PRINTS[fig.printCat]) {
    const { items, pagerHtml } = paginate(PRINTS[fig.printCat], _printPage, PRINT_PAGE_SIZE, 'setPrintPage');
    html += '<div class="co-grid">';
    items.forEach(p => {
      const preview = (SM.printPreviews || {})[p.id] || (SM.prints || {})[p.id];
      const bg = p.darkBg ? '#0E1422' : '#fff';
      const inner = preview
        ? `<div style="width:100%;aspect-ratio:1;background:${bg};border-radius:8px;overflow:hidden;position:relative"><img src="${spx(preview, SPX.tileZoom)}" style="position:absolute;width:100%;height:auto;top:-45%;left:0;transform:scale(2.6);transform-origin:50% 50%"></div>`
        : `<div style="font-size:20px;line-height:1">${p.emoji || p.label || p.id}</div>`;
      html += `<div class="co-item ${fig.print===p.id?'selected':''}" onclick="setPrint('${p.id}')">${inner}<div class="co-item-label">${p.label || p.id}</div></div>`;
    });
    html += '</div>' + pagerHtml;
  }
  if (fig.print) {
    html += `<div style="margin-top:10px"><button onclick="clearPrint()" style="width:100%;padding:9px;border-radius:8px;background:rgba(255,71,87,0.1);border:2px solid rgba(255,71,87,0.4);color:var(--danger);font-size:12px;font-weight:700;cursor:pointer;font-family:'Nunito',sans-serif;">✕ Прибрати принт</button></div>`;
  }
  html += '</div>';
  return html;
}

// ===== LEGS =====
function renderLegsPanel(fig) {
  let html = '<div class="co-section"><div class="co-section-title">4.1 Тип ніг</div><div class="co-types">';
  const LEG_OOS = ['dress'];
  LEG_TYPES.forEach(t => {
    const oos = LEG_OOS.includes(t.id);
    const click = oos ? "showOverlay('overlayOOS')" : `setLegsType('${t.id}')`;
    html += `<div class="co-type-btn ${fig.legsType===t.id?'selected':''} ${oos?'oos':''}" onclick="${click}" style="${oos?'opacity:.45;cursor:not-allowed':''}">${t.label}</div>`;
  });
  html += '</div></div>';
  const SM = window.SPRITE_MAP || {};
  const LEG_DISPLAY = {'flesh':'#F5CC7F','#DC2626':'#DC2626','#fff':'#F0F0F0','#9B59B6':'#9B59B6','#111827':'#111827','#5D4037':'#5D4037','#1E3A5F':'#1E3A5F','#A0522D':'#A0522D','#FCD34D':'#FCD34D','#15803D':'#15803D','#C2185B':'#C2185B','#F472B6':'#F472B6','#00B4D8':'#00B4D8','#FB923C':'#FB923C','#9CA3AF':'#9CA3AF'};
  const legPrefix = fig.legsType + '_';
  const availLegs = Object.keys(SM.legs||{}).filter(k => k.startsWith(legPrefix) && (SM.legs||{})[k]).map(k => k.replace(legPrefix,''));
  html += '<div class="co-section"><div class="co-section-title">4.2 Колір</div><div class="co-colors">';
  availLegs.forEach(colorKey => {
    const displayColor = LEG_DISPLAY[colorKey] || colorKey;
    html += `<div class="color-swatch ${fig.legsColor===colorKey?'selected':''}" style="background:${displayColor}" onclick="setLegsColor('${colorKey}')"></div>`;
  });
  html += '</div></div>';
  return html;
}

// ===== ACCESSORIES =====
// На мобілках — по 5 на сторінку, щоб не навантажувати телефон
const ACC_PAGE_SIZE = (window.innerWidth <= 768) ? 5 : 10;
const _accPage = { left: 0, right: 0 };

function setAccPage(side, page) {
  _accPage[side] = page;
  renderRightPanel();
}

// ── Превʼю аксесуарів ────────────────────────────────────────────────
// Спрайт лежить на спільному полотні 2500×3084, і сам предмет займає
// ледь третину. Тому в плитці він виглядав крихітним. Обрізаємо порожнечу
// й показуємо результат; малюємо один раз і запамʼятовуємо.
const ACC_THUMBS = {};
// Розмір, у якому тягнемо картинку для плитки вибору. Беремо ТОЙ САМИЙ, що
// прогрівається у фоні (SPX.tile): раніше тут було 220, і кожна плитка
// качала окрему копію з нуля — саме тому було видно, як вони проявляються.
const ACC_THUMB_PX = SPX.tile;
function accThumb(url, id) {
  const ready = ACC_THUMBS[id];
  setTimeout(() => fillAccThumb(url, id), 0);
  // Позначаємо атрибутом, а не id: боксерські рукавички стоять і в лівій,
  // і в правій сітці. З однаковим id браузер знаходив тільки перший кубик,
  // і в правій руці плитка лишалась порожньою.
  return '<div class="co-acc-img" data-accth="' + id + '">'
       + (ready ? '<img src="' + ready + '" alt="">' : '') + '</div>';
}
function trimImage(url, px) {
  return new Promise(resolve => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => {
      try {
        const cv = document.createElement('canvas');
        cv.width = im.naturalWidth; cv.height = im.naturalHeight;
        const cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(im, 0, 0);
        const d = cx.getImageData(0, 0, cv.width, cv.height).data;
        let x0 = cv.width, y0 = cv.height, x1 = -1, y1 = -1;
        for (let y = 0; y < cv.height; y++) {
          for (let x = 0; x < cv.width; x++) {
            if (d[(y * cv.width + x) * 4 + 3] > 8) {
              if (x < x0) x0 = x; if (x > x1) x1 = x;
              if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        if (x1 < 0) return resolve(url);
        const w = x1 - x0 + 1, h = y1 - y0 + 1;
        const out = document.createElement('canvas');
        out.width = w; out.height = h;
        out.getContext('2d').drawImage(cv, x0, y0, w, h, 0, 0, w, h);
        resolve(out.toDataURL('image/png'));
      } catch (e) { resolve(url); }
    };
    im.onerror = () => resolve(url);
    im.src = spx(url, px || ACC_THUMB_PX);
  });
}
async function fillAccThumb(url, id) {
  if (!url || ACC_THUMBS[id]) return;
  const sel = '[data-accth="' + id + '"]';
  if (!document.querySelector(sel)) return;
  const src = await trimImage(url);
  ACC_THUMBS[id] = src;
  document.querySelectorAll(sel).forEach(box => {
    box.innerHTML = '<img src="' + src + '" alt="">';
  });
}

function renderAccessoriesPanel(fig) {
  const SM = window.SPRITE_MAP || {};
  const accs = SM.accessories || {};
  const isBoxing = fig.accLeft === 'boxing';
  // Скільки аксесуарів — рахуємо по самому списку, а не вписуємо числом:
  // раніше тут стояло 50, і додані потім просто не показувались.
  const accTotal = Object.keys(accs)
    .filter(k => /^L_\d+$/.test(k) && accs[k]).length || 50;
  const totalPages = Math.ceil(accTotal / ACC_PAGE_SIZE);

  function accGrid(side) {
    const prefix  = side === 'left' ? 'L_' : 'R_';
    const curId   = side === 'left' ? fig.accLeft : fig.accRight;
    const page    = _accPage[side] || 0;
    const from    = page * ACC_PAGE_SIZE + 1;
    const to      = Math.min(from + ACC_PAGE_SIZE - 1, accTotal);

    let h = `<div class="co-section">
      <div class="co-section-title">${side==='left'?'5.1 Аксесуар ліворуч':'5.2 Аксесуар праворуч'} (+50 грн)</div>
      <div class="co-grid">`;

    // Без — завжди
    h += `<div class="co-item ${(!curId||isBoxing)?'selected':''}" data-acc-side="${side}" data-acc-id="none" onclick="setAcc('${side}',null)">
        <div class="co-item-img-placeholder" style="font-size:22px">&#x2716;&#xFE0F;</div>
        <div class="co-item-label">Без</div>
      </div>`;

    // Боксерські — завжди
    h += `<div class="co-item ${isBoxing?'selected':''}" data-acc-side="${side}" data-acc-id="boxing" onclick="setAcc('left','boxing')">
        ${accs.boxing ? `${accThumb(accs.boxing, 'boxing')}` : `<div class="co-item-img-placeholder">&#x1F94A;</div>`}
        <div class="co-item-label">&#x1F94A; обидві</div>
      </div>`;

    // Поточна сторінка (10 елементів)
    for (let i = from; i <= to; i++) {
      const oos     = (window.ACC_OOS || []).includes(i);
      const hasInfo = !!(window.ACC_INFO && window.ACC_INFO[i]);
      const accId   = prefix + i;
      const url     = accs[accId] || '';
      let clickFn;
      if (oos)          clickFn = 'showOOS()';
      else if (hasInfo) clickFn = 'showAccInfo(\''+side+'\',\''+accId+'\','+i+')';
      else              clickFn = 'setAcc(\''+side+'\',\''+accId+'\')';
      h += `<div class="co-item ${curId===accId&&!isBoxing?'selected':''} ${oos?'unavailable':''}" data-acc-side="${side}" data-acc-id="${accId}" onclick="${clickFn}">
          ${url ? `${accThumb(url, accId)}` : `<div class="co-item-img-placeholder">${i}</div>`}
          <div class="co-item-label">${i}${hasInfo?' ℹ':''}${oos?' ✕':''}</div>
        </div>`;
    }

    h += `</div>`;

    // Пагінація
    h += `<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;gap:8px">
        <button onclick="setAccPage('${side}',${page-1})" ${page===0?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===0?'#1B2433':'#252F42'};color:${page===0?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===0?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">← Назад</button>
        <span style="font-size:11px;color:var(--text-muted);white-space:nowrap">${page+1} / ${totalPages}</span>
        <button onclick="setAccPage('${side}',${page+1})" ${page===totalPages-1?'disabled':''} style="flex:1;padding:8px;border-radius:8px;border:2px solid #000;background:${page===totalPages-1?'#1B2433':'#252F42'};color:${page===totalPages-1?'#555':'var(--text)'};font-size:12px;font-weight:700;cursor:${page===totalPages-1?'not-allowed':'pointer'};font-family:'Nunito',sans-serif">Далі →</button>
      </div>
    </div>`;
    return h;
  }

  return accGrid('left') + accGrid('right');
}

window._pendingAccSide = null;
window._pendingAccId   = null;
function showAccInfo(side, accId, itemNum) {
  const info = window.ACC_INFO && window.ACC_INFO[itemNum];
  if (!info) { setAcc(side, accId); return; }
  window._pendingAccSide = side;
  window._pendingAccId   = accId;
  document.getElementById('accInfoTitle').textContent = info.title;
  document.getElementById('accInfoText').textContent  = info.text;
  document.getElementById('accInfoImg').src           = info.img;
  showOverlay('overlayAccInfo');
}
function confirmAccInfo() {
  hideOverlay('overlayAccInfo');
  if (window._pendingAccSide && window._pendingAccId) {
    setAcc(window._pendingAccSide, window._pendingAccId);
  }
  window._pendingAccSide = null;
  window._pendingAccId   = null;
}
function cancelAccInfo() {
  hideOverlay('overlayAccInfo');
  window._pendingAccSide = null;
  window._pendingAccId   = null;
}

// ===== KEYCHAIN =====
function renderKeychainPanel(fig) {
  const add = fig.type === 'human' ? 100 : 70;
  let html = `<div class="co-section"><div class="co-section-title">Зробити брелоком? (+${add} грн)</div>
    <div class="co-yesno">
      <div class="co-yn-btn yes ${fig.keychain?'selected':''}" onclick="setKeychain(true)">✓ Так</div>
      <div class="co-yn-btn no ${!fig.keychain?'selected':''}" onclick="setKeychain(false)">✕ Ні</div>
    </div>`;
  if (fig.keychain) {
    html += `<div style="margin-top:12px;background:var(--amber-dim);border:1px solid rgba(255,184,0,0.2);border-radius:8px;padding:12px;font-size:11px;color:var(--amber)">🔑 На фігурці буде відображено кільце брелка</div>`;
  }
  html += '</div>';
  return html;
}

// ===== PACKAGE =====
function renderPackagePanel(fig) {
  let html = '<div class="co-section"><div class="co-section-title">7.1 Оберіть упаковку</div><div style="display:grid;grid-template-columns:1fr 1fr;gap:8px">';
  PACKAGES.forEach(p => {
    if (p.available) {
      html += `<div class="co-item ${fig.package===p.id?'selected':''}" style="aspect-ratio:auto;padding:16px 10px" onclick="setPackage('${p.id}')"><div class="co-item-img-placeholder" style="font-size:28px">${p.emoji}</div><div class="co-item-label" style="font-size:10px;margin-top:6px">${p.label}</div></div>`;
    } else {
      html += `<div class="co-item unavailable" style="aspect-ratio:auto;padding:16px 10px" onclick="showOOS()"><div class="co-item-img-placeholder" style="font-size:28px">${p.emoji}</div><div class="co-item-label" style="font-size:10px;margin-top:6px">${p.label}</div></div>`;
    }
  });
  html += '</div></div>';
  return html;
}

// ===== EXTRA (animal only) =====
const CUSTOM_PAINT_OFF = true;   // покраска за фото тимчасово вимкнена
function renderExtraPanel(fig) {
  let html = '<div class="co-section"><div class="co-section-title">🎨 Покрасити за фото? (+250 грн)</div>';
  // Тимчасово вимкнено
  if (CUSTOM_PAINT_OFF) {
    html += `<div class="co-yesno">
      <div class="co-yn-btn yes disabled">✓ Так</div>
      <div class="co-yn-btn no selected">✕ Ні</div>
    </div>
    <div style="margin-top:10px;font-size:11px;color:var(--text-muted);line-height:1.5">
      Послуга тимчасово недоступна. Напишіть нам в Instagram — обговоримо індивідуально.
    </div></div>`;
    return html;
  }
  html += `<div class="co-yesno">
    <div class="co-yn-btn yes ${fig.customPaint?'selected':''}" onclick="setCustomPaint(true)">✓ Так</div>
    <div class="co-yn-btn no ${!fig.customPaint?'selected':''}" onclick="setCustomPaint(false)">✕ Ні</div>
  </div>`;
  if (fig.customPaint) {
    html += `<div style="margin-top:14px">
      <div style="font-size:11px;font-weight:600;color:var(--text-dim);margin-bottom:8px">Завантажте фото вашого улюбленця (до 3):</div>
      <div id="photosList"></div>
      ${fig.paintPhotos.length < 3 ? `<div class="upload-zone" id="uploadZone"><div class="upload-zone-icon">📷</div><div class="upload-zone-text">Натисніть щоб завантажити фото<br><span style="font-size:10px;color:var(--text-muted)">JPG, PNG до 10 МБ</span></div></div>` : ''}
      <div style="margin-top:10px;font-size:10px;color:var(--text-muted);line-height:1.5">
        Завантажуючи фото, ви погоджуєтесь на їх зберігання на захищеному сервері.
        <span style="color:var(--violet-light);cursor:pointer" onclick="showOverlay('overlayPrivacyInfo')">Детальніше</span>
      </div>
    </div>`;
  }
  html += '</div>';
  return html;
}

// ===== ADDONS PANEL =====
function renderAddonsPanel(fig) {
  // — Підставка (тільки для людини) —
  let html = '';
  if (fig.type !== 'animal' && !STAND_OFF) {
  html += '<div class="co-section"><div class="co-section-title">🪨 Підставка (+30 грн)</div>';
  html += `<div class="co-yesno">
    <div class="co-yn-btn yes ${fig.stand?'selected':''}" onclick="setStand(true)">✓ Так</div>
    <div class="co-yn-btn no ${!fig.stand?'selected':''}" onclick="setStand(false)">✕ Ні</div>
  </div>`;
  if (fig.stand) {
    html += '<div style="margin-top:14px"><div style="font-size:10px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#edd05c;margin-bottom:10px;padding-bottom:6px;border-bottom:2px solid rgba(0,0,0,.5);">Колір підставки</div>';
    html += '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:2px">';
    STAND_COLORS.forEach(sc => {
      const sel = fig.standColor === sc.id;
      const lightColors = ['#F0EBE3','#FCD34D','#E8B89A','#F472B6','#9CA3AF','#4ADE80'];
      html += `<div onclick="setStandColor(${sc.id})" style="cursor:pointer;border-radius:8px;border:${sel?'3px solid #edd05c':'2px solid #000'};background:${sc.color};box-shadow:0 3px 0 rgba(0,0,0,.5)${sel?',0 0 0 1px #edd05c':''};padding:10px 4px;text-align:center;transition:all .15s;">
        <div style="font-size:10px;font-weight:700;color:${lightColors.includes(sc.color)?'#1B2433':'#fff'};line-height:1.2">${sc.name}</div>
      </div>`;
    });
    html += '</div></div>';
  }
  html += '</div>';
  } // end if animal

  // — Брелок-серце —
  html += '<div class="co-section"><div class="co-section-title">💗 Половинка серця (+' + PRICES.heartKeychain + ' грн)</div>';
  // Превью зображення
  html += `<div style="margin-bottom:12px;border-radius:10px;overflow:hidden;border:2px solid #000;background:#fff;padding:6px;text-align:center;cursor:pointer" onclick="toggleHeartPreview()">
    <img id="heartPreviewImg" src="https://cdn.shopify.com/s/files/1/0830/7395/8141/files/Lego-Brelok-Ksztalt-Serce-Breloczek-walentynki-EAN-GTIN-5903246431421-Photoroom.png?v=1787175763" alt="Брелок-серце" style="width:100%;max-height:130px;object-fit:contain;display:block;">
    <div style="font-size:10px;color:rgba(27,36,51,.6);margin-top:4px;font-weight:600">натисни для збільшення</div>
  </div>`;
  html += `<div style="font-size:11px;color:var(--text-dim);margin-bottom:10px;line-height:1.5">Кожна фігурка бере свою половинку. Дві половинки складаються в ціле серце — для пари або друзів.</div>`;
  html += `<div class="co-yesno">
    <div class="co-yn-btn yes ${fig.heartKeychain?'selected':''}" onclick="trySetHeartKeychain(true)">💗 Так</div>
    <div class="co-yn-btn no ${!fig.heartKeychain?'selected':''}" onclick="trySetHeartKeychain(false)">✕ Ні</div>
  </div>`;
  if (fig.heartKeychain) {
    html += `<div style="margin-top:12px;background:rgba(244,114,182,.1);border:2px solid rgba(244,114,182,.4);border-radius:10px;padding:12px;font-size:11px;color:#f9a8d4;line-height:1.5">💗 Половинку серця додано! Значок ❤ буде видно на фігурці</div>`;
  }
  html += '</div>';
  return html;
}

function toggleHeartPreview() {
  const img = document.getElementById('heartPreviewImg');
  if (!img) return;
  if (img.style.maxHeight === 'none') {
    img.style.maxHeight = '130px';
  } else {
    img.style.maxHeight = 'none';
  }
}

function trySetHeartKeychain(val) {
  // Раніше ціле серце покривало дві фігурки, тому друга спроба викликала
  // попередження. Тепер кожна фігурка бере власну половинку — попереджати нема про що.
  setHeartKeychain(!!val);
}
function setHeartKeychain(val) {
  STATE.figures[STATE.currentIdx].heartKeychain = val;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
  if (val) showToast('Половинку серця додано 💗', 'success');
}
function setStand(val) {
  STATE.figures[STATE.currentIdx].stand = val;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
}
function setStandColor(id) {
  STATE.figures[STATE.currentIdx].standColor = id;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function clearPrint() {
  const fig = STATE.figures[STATE.currentIdx];
  fig.print = null; fig.printCat = null;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
  showToast('Принт прибрано', '');
}

function renderPhotosList() {
  const fig = STATE.figures[STATE.currentIdx];
  const list = document.getElementById('photosList');
  if (!list || !fig) return;
  list.innerHTML = '';
  fig.paintPhotos.forEach((src, i) => {
    const item = document.createElement('div');
    item.className = 'upload-photo-item';
    item.innerHTML = `
      <img src="${src}" alt="фото ${i+1}">
      <div class="upload-photo-del" onclick="removePhoto(${i})">✕</div>`;
    list.appendChild(item);
  });
}

function removePhoto(i) {
  const fig = STATE.figures[STATE.currentIdx];
  fig.paintPhotos.splice(i, 1);
  fig.paintPhotoUrls.splice(i, 1);
  renderRightPanel();
  setTimeout(renderPhotosList, 10);
  saveState();
}

// ===== SETTERS =====
function setSkin(id) {
  const fig = STATE.figures[STATE.currentIdx];
  fig.skin = id;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
}
function setFace(id) {
  STATE.figures[STATE.currentIdx].face = id;
  renderFigureSvg(); renderRightPanel(); saveState();
  showToast('Обличчя обрано ✓', 'success');
}
function setHairType(t) {
  STATE.figures[STATE.currentIdx].hairType = t;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function setHairColor(c) {
  const fig = STATE.figures[STATE.currentIdx];
  fig.hairColor = c;
  // Якщо поточний стиль недоступний у цьому кольорі — беремо перший доступний
  const SM = window.SPRITE_MAP || {};
  if (!((SM.hair || {})[`${fig.hairStyle}_${c}`] || {}).front) {
    const first = HAIR_STYLES.find(s => ((SM.hair || {})[`${s.id}_${c}`] || {}).front);
    if (first) fig.hairStyle = first.id;
  }
  _hairStylePage = 0;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function setHairStyle(id) { STATE.figures[STATE.currentIdx].hairStyle = id; renderFigureSvg(); renderRightPanel(); saveState(); showToast('Зачіску обрано ✓','success'); }
function setHatStyle(id) { STATE.figures[STATE.currentIdx].hatStyle = id; renderFigureSvg(); renderRightPanel(); saveState(); showToast('Убір обрано ✓','success'); }
function setTorsoColor(c) {
  STATE.figures[STATE.currentIdx].torsoColor = c;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function setSleeveColor(c) {
  STATE.figures[STATE.currentIdx].sleeveColor = c;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function setPrintCat(cat) { STATE.figures[STATE.currentIdx].printCat = cat; _printPage = 0; renderRightPanel(); saveState(); }
function setPrint(id) {
  const fig = STATE.figures[STATE.currentIdx]; fig.print = id;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
}
function setLegsType(t) {
  const fig = STATE.figures[STATE.currentIdx];
  fig.legsType = t;
  // Зберігаємо поточний колір якщо він є в новому типі, інакше перший доступний
  const SM = window.SPRITE_MAP || {};
  const available = Object.keys(SM.legs || {}).filter(k => k.startsWith(t + '_') && (SM.legs||{})[k]).map(k => k.replace(t + '_', ''));
  if (!available.includes(fig.legsColor)) {
    fig.legsColor = available[0] || 'flesh';
  }
  renderRightPanel(); renderFigureSvg(); updatePrices(); saveState();
}
function setLegsColor(c) {
  STATE.figures[STATE.currentIdx].legsColor = c;
  renderFigureSvg(); renderRightPanel(); saveState();
}
function setAcc(side, id) {
  const fig = STATE.figures[STATE.currentIdx];
  const wasBoxing = fig.accLeft === 'boxing' || fig.accRight === 'boxing';
  if (id === 'boxing') {
    fig.accLeft  = 'boxing';
    fig.accRight = 'boxing';
  } else if (!id) {
    if (wasBoxing) { fig.accLeft = null; fig.accRight = null; }
    else { if (side === 'left') fig.accLeft = null; else fig.accRight = null; }
  } else {
    if (wasBoxing) { fig.accLeft = null; fig.accRight = null; }
    if (side === 'left') fig.accLeft = id; else fig.accRight = id;
  }
  renderFigureSvg();
  // Якщо панель аксесуарів вже відкрита — оновлюємо тільки класи, не перебудовуємо DOM
  if (STATE.currentNav === 'accessories') {
    _updateAccSelection(fig);
  } else {
    renderRightPanel();
  }
  updatePrices(); saveState();
}

function _updateAccSelection(fig) {
  const isBoxing = fig.accLeft === 'boxing';
  document.querySelectorAll('#rightPanelBody .co-item[data-acc-side]').forEach(el => {
    const s  = el.dataset.accSide;
    const a  = el.dataset.accId;
    const cur = s === 'left' ? fig.accLeft : fig.accRight;
    const sel = (a === 'none'   && (!cur || isBoxing)) ||
                (a === 'boxing' && isBoxing) ||
                (a === cur      && !isBoxing && a !== 'none' && a !== 'boxing');
    el.classList.toggle('selected', sel);
  });
}
function setKeychain(val) {
  const fig = STATE.figures[STATE.currentIdx];
  if (val && fig.type === 'human' && fig.hairType === 'bald') {
    showOverlay('overlayBaldKeychain');
    return;
  }
  fig.keychain = val;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
}
function setPackage(id) { STATE.figures[STATE.currentIdx].package = id; renderRightPanel(); saveState(); showToast('Упаковку обрано ✓','success'); }
function setCustomPaint(val) {
  if (CUSTOM_PAINT_OFF) return;
  const fig = STATE.figures[STATE.currentIdx]; fig.customPaint = val;
  if (val) showOverlay('overlayPaint');
  if (!val) { fig.paintPhotos = []; fig.paintPhotoUrls = []; }
  renderRightPanel(); updatePrices();
  if (val) setTimeout(renderPhotosList, 50);
  saveState();
}

// ===== OOS =====
function showOOS() { showOverlay('overlayOOS'); }

// ===== PHOTO UPLOAD via Cloudinary =====
function tryUploadPhoto() {
  const fig = STATE.figures[STATE.currentIdx];
  if (fig.paintPhotos.length >= 3) { showToast('Максимум 3 фото', 'danger'); return; }
  showOverlay('overlayPrivacy');
}

function confirmUpload() {
  hideOverlay('overlayPrivacy');
  const input = document.createElement('input');
  input.type = 'file'; input.accept = 'image/*'; input.multiple = true;
  input.onchange = async e => {
    const fig = STATE.figures[STATE.currentIdx];
    const files = Array.from(e.target.files).slice(0, 3 - fig.paintPhotos.length);
    showToast('Завантаження фото...', '');

    for (const file of files) {
      const localUrl = URL.createObjectURL(file);
      fig.paintPhotos.push(localUrl);
      fig.paintPhotoUrls.push(''); // placeholder

      try {
        const cdnUrl = await uploadToCloudinary(file);
        fig.paintPhotoUrls[fig.paintPhotoUrls.length - 1] = cdnUrl;
      } catch(err) {
        // якщо Cloudinary не налаштований — залишаємо blob URL як fallback
        fig.paintPhotoUrls[fig.paintPhotoUrls.length - 1] = localUrl;
      }
    }

    renderRightPanel();
    setTimeout(renderPhotosList, 50);
    showToast(`${files.length} фото завантажено ✓`, 'success');
    saveState();
  };
  input.click();
}

async function uploadToCloudinary(file) {
  const { cloudName, uploadPreset } = SHOPIFY_CONFIG.cloudinary;
  if (!cloudName || cloudName === 'YOUR_CLOUD_NAME') throw new Error('Cloudinary not configured');

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  });
  if (!res.ok) throw new Error('Cloudinary upload failed');
  const data = await res.json();
  return data.secure_url;
}

// ===== SHARE =====
function shareFig() {
  const wrap = document.getElementById('shareFigWrap');
  wrap.innerHTML = document.getElementById('legoFigSvg').outerHTML;
  document.getElementById('share-page').classList.add('active');
}
function closeShare() { document.getElementById('share-page').classList.remove('active'); }

// ===== CART =====
function openCart() {
  const figList = document.getElementById('cartFigList');
  figList.innerHTML = '';
  const humans = STATE.figures.filter(f => f.type==='human').length;
  const animals = STATE.figures.filter(f => f.type==='animal').length;
  const parts = [];
  if (humans) parts.push(`${humans} ${humans===1?'фігурка':'фігурок'}`);
  if (animals) parts.push(`${animals} ${animals===1?'тваринка':'тваринок'}`);
  document.getElementById('cartFigCount').innerHTML = `📋 Ваш вибір: <strong style="color:var(--text)">${parts.join(' + ')}</strong>`;

  STATE.figures.forEach((f, i) => {
    const item = document.createElement('div'); item.className = 'cart-fig-item';
    item.innerHTML = `<div class="cart-fig-item-icon" id="cartThumb-${i}">${FIG_ICONS[f.type]}</div><div class="cart-fig-item-name">${FIG_NAMES[f.type]} ${i+1}</div><div class="cart-fig-item-price">${figurePrice(f)} грн</div>`;
    composeFigureThumb(f).then(url => {
      const el = document.getElementById('cartThumb-' + i);
      if (url && el) el.innerHTML = `<img src="${url}" alt="">`;
    });
    figList.appendChild(item);
  });

  STATE._discountPct = 0;
  document.getElementById('promoInput').value = '';
  updateCartTotals();
  showOverlay('overlayCart');
}

function updateCartTotals() {
  const subtotal = totalPrice();
  const discount = Math.round(subtotal * STATE._discountPct / 100);
  const final = subtotal - discount;
  document.getElementById('cartSubtotal').textContent = subtotal + ' грн';
  document.getElementById('cartTotal').textContent = final + ' грн';
  document.getElementById('cartTotalBtn').textContent = final + ' грн';
}

function addFromCart(type) { hideOverlay('overlayCart'); addFigFromPanel(type); }

function applyPromo() {
  const code = document.getElementById('promoInput').value.trim().toUpperCase();
  if (code === 'BRICK10') {
    STATE._discountPct = 10;
    updateCartTotals();
    showToast('Промокод застосовано! -10% 🎉', 'success');
  } else {
    showToast('Промокод не знайдено', 'danger');
  }
}

// ===== CHECKOUT → Shopify =====
// Крок 1: показуємо нагадування зберегти зображення
function finalCheckout() {
  hideOverlay('overlayCart');
  showOverlay('overlaySaveImg');
}
// Крок 2: після "Добре" — реальне додавання в кошик і генерація картинки
function confirmSaveImg() {
  hideOverlay('overlaySaveImg');
  runCheckout();
}

async function runCheckout() {
  const n = STATE.figures.length;
  let count = 0;
  showOverlay('overlayLoading');
  document.getElementById('loadingTitle').textContent = `ДОДАЄМО ФІГУРКИ... 0/${n}`;

  // Перевіряємо налаштування Shopify
  const { variants } = SHOPIFY_CONFIG;
  const configured = Object.values(variants).every(v => v && !v.startsWith('VARIANT_ID'));

  if (!configured) {
    // Режим розробки: показуємо структуру замість реального відправлення
    const items = buildCartItems();
    console.log('[BrickStudio] Cart items to add:', JSON.stringify(items, null, 2));
    await simulateLoading(n, count);
    hideOverlay('overlayLoading');
    showToast('DEV MODE: дивись консоль (F12) — variant IDs ще не вписані', 'danger');
    return;
  }

  try {
    const items = buildCartItems();

    // анімація прогресу
    for (let i = 0; i < n; i++) {
      await new Promise(r => setTimeout(r, 600));
      document.getElementById('loadingTitle').textContent = `ДОДАЄМО ФІГУРКИ... ${i+1}/${n}`;
    }

    // Shopify відхиляє весь запит цілком, якщо хоч один рядок проблемний,
    // а 22 фігурки — це під сотню рядків. Тому додаємо частинами:
    // так і запит не роздувається, і видно, на чому саме воно спіткнулось.
    const CHUNK = 10;
    for (let i = 0; i < items.length; i += CHUNK) {
      const part = items.slice(i, i + CHUNK);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: part })
      });
      if (!res.ok) {
        let why = 'код ' + res.status;
        try {
          const j = await res.json();
          why = j.description || j.message || why;
        } catch (e) {}
        const err = new Error(why);
        err.userMsg = why;
        throw err;
      }
    }

    hideOverlay('overlayLoading');
    showToast('Фігурки додано в кошик! 🛒', 'success');

  } catch (err) {
    hideOverlay('overlayLoading');
    // Показуємо справжню причину, інакше незрозуміло, що робити далі
    const why = (err && (err.userMsg || err.message)) || '';
    showToast(why ? 'Кошик: ' + why : 'Помилка додавання в кошик. Спробуй ще раз.', 'danger');
    console.error('[BrickStudio] Checkout error:', err);
    return;
  }

  // Картинка зі зведенням — окремо від кошика. З двома десятками фігурок
  // полотно виходить величезним і браузер може не витягнути; раніше цей збій
  // прилітав у той самий catch і виглядав як помилка кошика.
  try { await generateFiguresImage(); }
  catch (e) { console.error('[BrickStudio] Summary image failed:', e); }
}

function buildCartItems() {
  const { variants } = SHOPIFY_CONFIG;
  const items = [];

  STATE.figures.forEach((fig, idx) => {
    const figNum = idx + 1;
    const figLabel = `${FIG_NAMES[fig.type]} ${figNum}`;

    // Базові властивості фігурки для адмінки Shopify
    const baseProps = {
      '№ фігурки': String(figNum),
      'Тип': FIG_NAMES[fig.type],
    };

    if (fig.type === 'human') {
      Object.assign(baseProps, {
        'Шкіра':        fig.skin,
        'Обличчя':      `#${fig.face + 1}`,
        'Зачіска':      fig.hairType,
        'Колір волосся':fig.hairColor,
        'Торс':         fig.torsoColor,
        'Рукави':       fig.sleeveColor,
        'Ноги':         `${fig.legsType} / ${fig.legsColor}`,
      });
    } else {
      Object.assign(baseProps, {
        'Тваринка':     ANIMALS.find(a => a.id === fig.animalType)?.label || fig.animalType,
      });
    }

    if (fig.package) baseProps['Упаковка'] = fig.package;

    // Фото для покраски — Cloudinary URLs
    if (fig.paintPhotoUrls && fig.paintPhotoUrls.filter(Boolean).length > 0) {
      baseProps['Фото для покраски'] = fig.paintPhotoUrls.filter(Boolean).join(' | ');
    }

    // 1. Базова фігурка
    items.push({
      id: fig.type === 'human' ? variants.human : variants.animal,
      quantity: 1,
      properties: { ...baseProps, 'Позиція': 'Фігурка' }
    });

    // 2. Брелок
    if (fig.keychain) {
      items.push({
        id: fig.type === 'human' ? variants.keychain_human : variants.keychain_animal,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel }
      });
    }

    // 3. Принт (тільки люди)
    if (fig.print) {
      const printEmoji = Object.values(PRINTS).flat().find(p => p.id === fig.print)?.emoji || fig.print;
      items.push({
        id: variants.print,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel, 'Принт': `${fig.printCat} — ${printEmoji}` }
      });
    }

    // 4. Аксесуари
    if (fig.accLeft === 'boxing') {
      items.push({
        id: variants.accessory,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel, 'Аксесуар': 'Боксерські рукавички (обидві руки)' }
      });
    } else {
      [{id: fig.accLeft, side:'ліва'},{id: fig.accRight, side:'права'}].filter(a => a.id).forEach(a => {
        items.push({
          id: variants.accessory, quantity: 1,
          properties: { '№ фігурки': String(figNum), 'Для': figLabel, 'Аксесуар': a.id, 'Рука': a.side }
        });
      });
    }

    // 5. Покраска за фото
    if (fig.customPaint) {
      items.push({
        id: variants.customPaint,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel }
      });
    }

    // 6. Підставка
    if (fig.stand && !STAND_OFF && variants.stand) {
      const sc = STAND_COLORS.find(c => c.id === (fig.standColor || 1));
      items.push({
        id: variants.stand,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel, 'Колір підставки': sc ? sc.name : '' }
      });
    }

    // 7. Брелок-серце
    if (fig.heartKeychain && variants.heartKeychain) {
      items.push({
        id: variants.heartKeychain,
        quantity: 1,
        properties: { '№ фігурки': String(figNum), 'Для': figLabel }
      });
    }
  });

  return items;
}

async function simulateLoading(n) {
  for (let i = 0; i < n; i++) {
    await new Promise(r => setTimeout(r, 700));
    document.getElementById('loadingTitle').textContent = `ДОДАЄМО ФІГУРКИ... ${i+1}/${n}`;
  }
  await new Promise(r => setTimeout(r, 600));
}

// Готове тіло за номером. Немає такого — беремо перше, щоб фігурка
// не лишилась без тулуба через прибране з бібліотеки посилання.
function readyBody(fig) {
  const lib = window.READY_FIGS || [];
  return lib.find(r => r.id === (fig && fig.readyId)) || lib[0] || null;
}

// ===== SVG RENDER =====
function renderFigureSvg() {
  const fig = STATE.figures[STATE.currentIdx];
  if (!fig) return;
  updateRotateBtn();
  // Мініатюра в смузі фігурок має показувати те саме, що й на сцені. Раніше
  // її оновлювали лише ті кнопки, що міняють ціну, тож після вибору
  // тваринки, обличчя чи зачіски в комірці лишалась стара картинка.
  refreshFigChip();
  if (fig.type === 'item')   { renderItemSvg(fig); return; }
  if (fig.type === 'animal') { renderAnimalSvg(fig); return; }

  // Показуємо людину, ховаємо тваринку
  const figWrap    = document.getElementById('figWrap');
  const animalWrap = document.getElementById('animalWrap');
  if (figWrap) { figWrap.style.display=''; figWrap.style.opacity=''; figWrap.style.pointerEvents=''; }
  if (animalWrap) animalWrap.style.display='none';
  window._showScaleRef = false;
  const figDisplay2 = document.getElementById('figDisplay');
  if (figDisplay2) figDisplay2.classList.remove('scale-ref-mode');
  const oldScaleWrap = document.getElementById('scaleRefWrap');
  if (oldScaleWrap) oldScaleWrap.style.display = 'none';

  const SM = window.SPRITE_MAP || {};

  function setLayer(id, url) {
    const el = document.getElementById(id);
    if (!el) return;
    url = spx(url, SPX.figure);
    if (url) {
      if (el.src !== url) el.src = url;
      el.style.display = '';
    } else {
      el.style.display = 'none';
      // src не очищаємо — браузер тримає в кеші
    }
  }

  const skin = fig.type === 'ready' ? 'flesh' : (fig.skin || 'flesh');
  const isBack = fig.facing === 'back';
  const T  = SM.torso    || {};
  const AF = SM.arms     || {};
  const AB = SM.armsBack || {};
  const L  = isBack ? (SM.legsBack || {}) : (SM.legs || {});

  // Готова фігурка: усе тіло — одна картинка, тож окремі торс/руки/ноги
  // не малюємо. Зверху лишаються тільки голова, обличчя, зачіска й аксесуари.
  const ready = fig.type === 'ready' ? readyBody(fig) : null;
  setLayer('layerBody', ready ? (isBack ? ready.back : ready.front) : null);

  setLayer('layerHead',     (SM.head || {})[skin]);
  setLayer('layerFace',     isBack ? null : (SM.faces || {})[fig.face ?? 0]);
  setLayer('layerHands',    (ready || isBack) ? null : (SM.hands || {})[skin]);
  setLayer('layerHandsBack',(!ready && isBack) ? SM.handsBack : null);
  // Завжди встановлюємо src для обох, просто перемикаємо видимість
  const frontArmsUrl = AF[fig.sleeveColor] || AF[fig.torsoColor] || AF[skin];
  const backArmsUrl  = AB[fig.sleeveColor] || AB[fig.torsoColor] || AB[skin];
  const elA  = document.getElementById('layerArms');
  const elAB = document.getElementById('layerArmsBack');
  if (elA)  { const fu = spx(frontArmsUrl, SPX.figure); if (fu && elA.src !== fu) elA.src = fu;  elA.style.display  = (ready || isBack) ? 'none' : ''; }
  if (elAB) { const bu = spx(backArmsUrl, SPX.figure); if (bu && elAB.src !== bu) elAB.src = bu;   elAB.style.display = (!ready && isBack) ? '' : 'none'; }
  setLayer('layerTorso', ready ? null : (T[fig.torsoColor] || T[skin]));
  setLayer('layerPrint', (!ready && !isBack && fig.print) ? (SM.prints || {})[fig.print] : null);
  // Волосся / головний убір — обидва 3-шарові {front, back, rear}
  let hw = null;
  if (fig.hairType === 'hat')  hw = (SM.hats || {})[fig.hatStyle];
  if (fig.hairType === 'hair') hw = (SM.hair || {})[`${fig.hairStyle}_${fig.hairColor}`];
  hw = hw || {};
  setLayer('layerHair', null);
  setLayer('layerHatFront', isBack ? hw.rear : hw.front);
  setLayer('layerHatBack',  !isBack ? hw.back : null);
  setLayer('layerLegs',  ready ? null : L[`${fig.legsType}_${fig.legsColor}`]);
  // Аксесуари — сумка (#32) має окремий шар (під руками), boxing — одна картинка на обидві
  const accs = SM.accessories || {};
  const isBoxing = fig.accLeft === 'boxing';
  const showAccLeft  = !isBack && fig.accLeft  && !isBoxing;
  const showAccRight = !isBack && fig.accRight && !isBoxing;
  // Сумка звичайно ховається під руки, але готове тіло — суцільна картинка,
  // під нею її б не було видно. Тому для готових фігурок кладемо її зверху.
  const isBagLeft  = !ready && showAccLeft  && fig.accLeft  === 'L_32';
  const isBagRight = !ready && showAccRight && fig.accRight === 'R_32';
  // layerBagL/R — сумка (під руками)
  setLayer('layerBagL', isBagLeft  ? accs['L_32'] : null);
  setLayer('layerBagR', isBagRight ? accs['R_32'] : null);
  // Боксерські рукавички — одна картинка в layerAccL, layerAccR прихований
  if (!isBack && isBoxing && accs.boxing) {
    setLayer('layerAccL', accs.boxing);
    setLayer('layerAccR', null);
  } else {
    setLayer('layerAccL', !isBagLeft  && showAccLeft  ? accs[fig.accLeft]  : null);
    setLayer('layerAccR', !isBagRight && showAccRight ? accs[fig.accRight] : null);
  }

  // Підставка — PNG якщо є, інакше кольоровий div
  const sc = STAND_COLORS.find(s => s.id === fig.standColor);
  const standPng = sc ? (SM.stand || {})[sc.id] : null;
  const standDiv = document.getElementById('layerStandDiv');
  if (figStand(fig)) {
    if (standPng) {
      setLayer('layerStand', standPng);
      if (standDiv) standDiv.style.display = 'none';
    } else {
      setLayer('layerStand', null);
      if (standDiv && sc) { standDiv.style.display = ''; standDiv.style.background = sc.color; }
    }
  } else {
    setLayer('layerStand', null);
    if (standDiv) standDiv.style.display = 'none';
  }

  setLayer('layerHeartKc', null); // PNG шар серця не використовується
  // Брелок-ключик — маленький значок справа зверху
  const kcBadge = document.getElementById('keychainBadge');
  if (kcBadge) {
    if (fig.keychain && SM.keychain) { kcBadge.src = spx(SM.keychain, SPX.tile); kcBadge.style.display = ''; }
    else kcBadge.style.display = 'none';
  }
  // Брелок-серце — маленький значок зліва зверху
  const heartBadge = document.getElementById('heartBadge');
  if (heartBadge) {
    if (fig.heartKeychain) { heartBadge.style.display = ''; }
    else heartBadge.style.display = 'none';
  }
}

window._showScaleRef = false;
function _renderHumanLayersOnly(fig) {
  const SM = window.SPRITE_MAP || {};
  const setLayerSrc = (id, src) => { const el = document.getElementById(id); if (el) { el.src = spx(src, SPX.figure) || ''; el.style.display = src ? '' : 'none'; } };
  const skin = fig.skin || 'flesh';
  const isBack = fig.facing === 'back';
  const T  = SM.torso    || {};
  const AF = SM.arms     || {};
  const AB = SM.armsBack || {};
  const L  = isBack ? (SM.legsBack || {}) : (SM.legs || {});
  setLayerSrc('layerHead',      (SM.head  || {})[skin]);
  setLayerSrc('layerFace',      isBack ? null : (SM.faces || {})[fig.face ?? 0]);
  setLayerSrc('layerHands',     isBack ? null : (SM.hands || {})[skin]);
  setLayerSrc('layerHandsBack', isBack ? SM.handsBack : null);
  const frontArmsUrl = AF[fig.sleeveColor] || AF[fig.torsoColor] || AF[skin];
  const backArmsUrl  = AB[fig.sleeveColor] || AB[fig.torsoColor] || AB[skin];
  const elA  = document.getElementById('layerArms');
  const elAB = document.getElementById('layerArmsBack');
  if (elA)  { elA.src  = spx(frontArmsUrl, SPX.figure) || '';  elA.style.display  = (!isBack && frontArmsUrl) ? '' : 'none'; }
  if (elAB) { elAB.src = spx(backArmsUrl, SPX.figure) || '';  elAB.style.display = (isBack  && backArmsUrl)  ? '' : 'none'; }
  setLayerSrc('layerTorso', T[fig.torsoColor] || T[skin]);
  setLayerSrc('layerPrint', (!isBack && fig.print) ? (SM.prints || {})[fig.print] : null);
  let hw = null;
  if (fig.hairType === 'hat')  hw = (SM.hats || {})[fig.hatStyle];
  if (fig.hairType === 'hair') hw = (SM.hair || {})[`${fig.hairStyle}_${fig.hairColor}`];
  hw = hw || {};
  setLayerSrc('layerHair', null);
  setLayerSrc('layerHatFront', isBack ? hw.rear : hw.front);
  setLayerSrc('layerHatBack',  !isBack ? hw.back : null);
  setLayerSrc('layerLegs',  L[`${fig.legsType}_${fig.legsColor}`]);
  const accs = SM.accessories || {};
  const isBoxing = fig.accLeft === 'boxing';
  setLayerSrc('layerBagL', (!isBack && fig.accLeft  === 'L_32') ? accs['L_32'] : null);
  setLayerSrc('layerBagR', (!isBack && fig.accRight === 'R_32') ? accs['R_32'] : null);
  if (!isBack && isBoxing && accs.boxing) {
    setLayerSrc('layerAccL', accs.boxing); setLayerSrc('layerAccR', null);
  } else {
    setLayerSrc('layerAccL', (!isBack && fig.accLeft  && !isBoxing && fig.accLeft  !== 'L_32') ? accs[fig.accLeft]  : null);
    setLayerSrc('layerAccR', (!isBack && fig.accRight && !isBoxing && fig.accRight !== 'R_32') ? accs[fig.accRight] : null);
  }
  const sc = STAND_COLORS.find(s => s.id === fig.standColor);
  setLayerSrc('layerStand', (figStand(fig) && sc) ? (SM.stand || {})[sc.id] : null);
  setLayerSrc('layerHeartKc', null);
}

function toggleScaleRef() {
  window._showScaleRef = !window._showScaleRef;
  if (window._showScaleRef) {
    const humanFig = STATE.figures.find(f => f.type === 'human');
    if (!humanFig) {
      // Немає людини — дефолтні flesh-спрайти
      const SM = window.SPRITE_MAP || {};
      const setLayerSrc = (id, src) => { const el = document.getElementById(id); if (el) { el.src = spx(src, SPX.figure) || ''; el.style.display = src ? '' : 'none'; } };
      setLayerSrc('layerLegs',   SM.legs  && SM.legs['normal_flesh'] || '');
      setLayerSrc('layerArms',   SM.arms  && SM.arms['flesh']        || '');
      setLayerSrc('layerTorso',  SM.torso && SM.torso['flesh']       || '');
      setLayerSrc('layerHands',  SM.hands && SM.hands['flesh']       || '');
      setLayerSrc('layerHead',   SM.head  && SM.head['flesh']        || '');
      setLayerSrc('layerFace',   SM.faces && SM.faces[0]             || '');
      ['layerHair','layerHatFront','layerHatBack','layerAccL','layerAccR','layerPrint','layerStand','layerHeartKc','layerBagL','layerBagR'].forEach(id => {
        const el = document.getElementById(id); if (el) { el.src=''; el.style.display='none'; }
      });
    } else {
      // Є людина — рендеримо її шари в figWrap
      _renderHumanLayersOnly(humanFig);
    }
  }
  renderFigureSvg();
}

// Предмет показуємо однією картинкою — так само, як тваринку,
// тільки джерело беремо з бібліотеки предметів редактора рамок.
function renderItemSvg(fig) {
  const figWrap = document.getElementById('figWrap');
  const animalWrap = document.getElementById('animalWrap');
  if (figWrap) figWrap.style.display = 'none';
  if (animalWrap) animalWrap.style.display = '';
  const el = document.getElementById('animalImg');
  const it = (window.FE_ITEM_LIB || []).find(x => x.id === fig.itemId);
  if (el) {
    if (it) { el.src = spx(it.url, SPX.figure); el.style.display = ''; }
    else el.style.display = 'none';
  }
  ['heartBadge','animalHeartBadge','kcBadge'].forEach(id => {
    const b = document.getElementById(id); if (b) b.style.display = 'none';
  });
}
// Панель вибору предмета — сітка з обрізаними превʼю, як в аксесуарів
function renderItemPanel(fig) {
  const lib = window.FE_ITEM_LIB || [];
  if (!lib.length) {
    return '<div class="co-section"><div class="co-section-title">Предмети</div>'
         + '<p style="font-size:12px;color:var(--text-dim)">Список предметів ще не завантажено.</p></div>';
  }
  let h = '<div class="co-section"><div class="co-section-title">Оберіть предмет (+'
        + PRICES.accessory + ' грн)</div><div class="co-grid">';
  lib.forEach(it => {
    // soon: предмет уже намальований, але поки не беремо в роботу
    const off = !!it.soon;
    h += '<div class="co-item ' + (fig.itemId === it.id ? 'selected' : '')
       + (off ? ' unavailable' : '') + '"'
       + ' onclick="' + (off ? 'showItemSoon()' : 'setItem(\'' + it.id + '\')') + '">'
       + accThumb(it.url, 'it_' + it.id)
       + '<div class="co-item-label">' + (it.name || it.id) + (off ? ' ✕' : '') + '</div></div>';
  });
  return h + '</div></div>';
}
function showItemSoon() {
  showToast('Цей предмет поки недоступний — зʼявиться згодом', 'danger');
}
function setItem(id) {
  const fig = STATE.figures[STATE.currentIdx];
  if (!fig) return;
  fig.itemId = id;
  renderFigureSvg(); renderRightPanel(); updatePrices(); saveState();
  showToast('Предмет обрано ✓', 'success');
}
function renderAnimalSvg(fig) {
  const figWrap    = document.getElementById('figWrap');
  const animalWrap = document.getElementById('animalWrap');
  if (animalWrap) animalWrap.style.display = '';

  // Напівпрозора людина для масштабу
  const figDisplay = document.getElementById('figDisplay');
  if (window._showScaleRef) {
    if (figWrap)    { figWrap.style.display=''; figWrap.style.opacity='0.28'; figWrap.style.pointerEvents='none'; }
    if (figDisplay) figDisplay.classList.add('scale-ref-mode');
  } else {
    if (figWrap)    { figWrap.style.display='none'; figWrap.style.opacity=''; figWrap.style.pointerEvents=''; }
    if (figDisplay) figDisplay.classList.remove('scale-ref-mode');
  }

  // Кнопка під canvas (статичний елемент в HTML)
  const scaleWrap = document.getElementById('scaleRefWrap');
  const scaleBtn  = document.getElementById('scaleRefBtn');
  if (scaleWrap) scaleWrap.style.display = '';
  if (scaleBtn) {
    scaleBtn.textContent = window._showScaleRef ? '✕ Сховати фігурку' : '👤 Масштаб з фігуркою';
    scaleBtn.style.borderColor = window._showScaleRef ? 'rgba(237,208,92,0.9)' : 'rgba(237,208,92,0.45)';
    scaleBtn.style.background  = window._showScaleRef ? 'rgba(237,208,92,0.15)' : 'rgba(0,0,0,0.45)';
  }

  const SM = window.SPRITE_MAP || {};
  const animalImgEl = document.getElementById('animalImg');
  if (animalImgEl) {
    const url = SM.animals && SM.animals[fig.animalType] ? SM.animals[fig.animalType] : '';
    if (url) { animalImgEl.src = spx(url, SPX.figure); animalImgEl.style.display = ''; }
    else animalImgEl.style.display = 'none';
  }

  // Брелок
  const kcBadge = document.getElementById('animalKeychainBadge');
  if (kcBadge) {
    if (fig.keychain && SM.keychain) { kcBadge.src = spx(SM.keychain, SPX.tile); kcBadge.style.display = ''; }
    else kcBadge.style.display = 'none';
  }
  // Серце-брелок (src вже вшитий в HTML)
  const animalHeart = document.getElementById('animalHeartBadge');
  if (animalHeart) {
    if (fig.heartKeychain) animalHeart.style.display = '';
    else animalHeart.style.display = 'none';
  }
}

// ===== GENERATE IMAGE =====
function getFigureLayerUrls(fig) {
  const SM = window.SPRITE_MAP || {};
  const urls = [];
  const add = u => u && urls.push(u);

  if (fig.type === 'item') {
    const it = (window.FE_ITEM_LIB || []).find(x => x.id === fig.itemId);
    add(it && it.url);
    return urls;
  }
  if (fig.type === 'animal') {
    add(SM.animals && SM.animals[fig.animalType]);
    return urls;
  }

  const isReady = fig.type === 'ready';
  const skin   = isReady ? 'flesh' : (fig.skin || 'flesh');
  const isBack = fig.facing === 'back';
  const T  = SM.torso    || {};
  const AF = SM.arms     || {};
  const AB = SM.armsBack || {};
  const L  = isBack ? (SM.legsBack || {}) : (SM.legs || {});
  let hw = null;
  if (fig.hairType === 'hat')  hw = (SM.hats || {})[fig.hatStyle];
  if (fig.hairType === 'hair') hw = (SM.hair || {})[`${fig.hairStyle}_${fig.hairColor}`];
  hw = hw || {};

  if (!isBack) add(hw.back); // задній шар убору/волосся — позаду всього
  if (isReady) {
    const rb = readyBody(fig);
    add(rb && (isBack ? rb.back : rb.front));
  } else {
    add(L[`${fig.legsType}_${fig.legsColor}`]);
    if (isBack) {
      add(SM.handsBack);
      add(AB[fig.sleeveColor] || AB[fig.torsoColor] || AB[skin]);
    } else {
      add(AF[fig.sleeveColor] || AF[fig.torsoColor] || AF[skin]);
    }
    add(T[fig.torsoColor] || T[skin]);
    if (!isBack && fig.print) add((SM.prints || {})[fig.print]);
  }

  const accs = SM.accessories || {};
  const isBoxing = fig.accLeft === 'boxing';
  // у готової фігурки долоні вже намальовані на тілі, а сумка йде поверх
  if (!isBack && !isReady) {
    if (fig.accLeft  === 'L_32') add(accs['L_32']);
    if (fig.accRight === 'R_32') add(accs['R_32']);
    add((SM.hands || {})[skin]);
  }

  if (!isBack && isBoxing) {
    add(accs.boxing);
  } else if (!isBack) {
    if (fig.accLeft  && (isReady || fig.accLeft  !== 'L_32')) add(accs[fig.accLeft]);
    if (fig.accRight && (isReady || fig.accRight !== 'R_32')) add(accs[fig.accRight]);
  }

  add((SM.head || {})[skin]);
  if (!isBack) add((SM.faces || {})[fig.face ?? 0]);
  add(isBack ? hw.rear : hw.front);

  if (figStand(fig)) {
    const sc = STAND_COLORS.find(s => s.id === fig.standColor);
    if (sc) add((SM.stand || {})[sc.id]);
  }
  return urls;
}

function getFigureSummaryLines(fig, idx) {
  const lines = [];
  const price = figurePrice(fig);
  const isHuman = fig.type === 'human' || fig.type === 'ready';

  const nm = fig.type === 'human' ? 'Фігурка' : (FIG_NAMES[fig.type] || 'Тваринка');
  lines.push({ text: nm + ' ' + (idx + 1), bold: true, color: '#EDD05C' });
  if (fig.type === 'ready') {
    const rb = readyBody(fig);
    if (rb) lines.push({ text: 'Готове тіло: ' + rb.label, color: '#94a3b8' });
  }

  if (isHuman) {
    const faceObj = (window.FACES || []).find(f => f.id === fig.face);
    if (faceObj) lines.push({ text: 'Обличчя: ' + (faceObj.label || faceObj.id), color: '#94a3b8' });
    if (fig.hairType === 'hair') lines.push({ text: 'Зачіска: Стиль ' + fig.hairStyle, color: '#94a3b8' });
    if (fig.hairType === 'hat')  lines.push({ text: 'Убір: ' + fig.hatStyle, color: '#94a3b8' });
    if (fig.print) lines.push({ text: 'Принт: ' + fig.print, color: '#94a3b8' });
  }

  lines.push({ text: 'Брелок: ' + (fig.keychain ? 'Так' : 'Ні'), color: fig.keychain ? '#86efac' : '#94a3b8' });

  if (fig.heartKeychain) lines.push({ text: 'Половинка серця', color: '#f9a8d4' });

  if (isHuman && figStand(fig)) {
    const sc = STAND_COLORS.find(s => s.id === fig.standColor);
    lines.push({ text: 'Підставка: ' + (sc?.name || 'Так'), color: '#86efac', swatch: sc?.color });
  }

  lines.push({ text: 'Ціна: ' + price + ' грн', bold: true, color: '#EDD05C' });
  return lines;
}

async function generateFiguresImage() {
  const figures = STATE.figures;
  if (!figures || !figures.length) return;

  const FW = 480, FH = 590;
  const INFO_H = 220;
  const PAD = 28;
  const CARD_W = FW;
  const CARD_H = FH + INFO_H;
  const cols = Math.min(figures.length, 3);
  const rows = Math.ceil(figures.length / cols);
  const CW = CARD_W * cols + PAD * (cols + 1);
  const CH = CARD_H * rows + PAD * (rows + 1) + 40;

  // Два десятки фігурок дають полотно висотою під 7000 px — Safari на телефоні
  // такого не тягне й повертає порожній файл. Тому малюємо в тому ж масштабі,
  // але стискаємо все полотно до безпечних меж.
  const MAX_SIDE = 4096, MAX_AREA = 16e6;
  const scale = Math.min(1, MAX_SIDE / CW, MAX_SIDE / CH, Math.sqrt(MAX_AREA / (CW * CH)));

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(CW * scale); canvas.height = Math.round(CH * scale);
  const ctx = canvas.getContext('2d');
  if (scale < 1) ctx.scale(scale, scale);

  // Фон
  ctx.fillStyle = '#0E1422';
  ctx.fillRect(0, 0, CW, CH);

  const loadImg = url => new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = url;
  });

  for (let i = 0; i < figures.length; i++) {
    const col = i % cols;
    const row = Math.floor(i / cols);
    const x = PAD + col * (CARD_W + PAD);
    const y = PAD + row * (CARD_H + PAD);

    // Фон картки
    ctx.fillStyle = '#141d2e';
    ctx.beginPath();
    ctx.roundRect(x, y, CARD_W, CARD_H, 12);
    ctx.fill();

    // Спрайти фігурки
    const urls = getFigureLayerUrls(figures[i]);
    for (const url of urls) {
      const img = await loadImg(url);
      if (img) ctx.drawImage(img, x, y, FW, FH);
    }

    // Розділювач
    ctx.strokeStyle = 'rgba(237,208,92,0.2)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(x + 16, y + FH + 1);
    ctx.lineTo(x + CARD_W - 16, y + FH + 1);
    ctx.stroke();

    // Текст інфо
    const lines = getFigureSummaryLines(figures[i], i);
    let ty = y + FH + 18;
    const LINE_H = 22;
    const COL2 = x + CARD_W / 2;

    // Два стовпці: ліва половина / права половина
    const half = Math.ceil((lines.length - 1) / 2); // без першого рядка (заголовок)
    const header = lines[0];
    const rest   = lines.slice(1);

    // Заголовок по центру
    ctx.font = 'bold 20px sans-serif';
    ctx.fillStyle = header.color || '#EDD05C';
    ctx.textAlign = 'center';
    ctx.fillText(header.text, x + CARD_W / 2, ty);
    ty += LINE_H + 4;

    // Всі рядки зліва, ціна справа
    const priceItem = rest.find(l => l.bold);
    const infoItems = rest.filter(l => !l.bold);

    // Ліва колонка — перелік
    let ly = ty;
    ctx.textAlign = 'left';
    infoItems.forEach(line => {
      ctx.font = '14px sans-serif';
      ctx.fillStyle = line.color || '#cbd5e1';
      ctx.fillText(line.text, x + 16, ly);
      if (line.swatch) {
        const tw = ctx.measureText(line.text).width;
        ctx.fillStyle = line.swatch;
        ctx.beginPath();
        ctx.roundRect(x + 16 + tw + 6, ly - 12, 14, 14, 3);
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,0.3)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }
      ly += LINE_H;
    });

    // Ціна — справа по центру по висоті блоку
    if (priceItem) {
      ctx.font = 'bold 20px sans-serif';
      ctx.fillStyle = priceItem.color || '#EDD05C';
      ctx.textAlign = 'right';
      const midY = ty + (infoItems.length * LINE_H) / 2 + 6;
      ctx.fillText(priceItem.text, x + CARD_W - 16, midY);
    }
  }

  // Лого знизу
  ctx.font = 'bold 20px sans-serif';
  ctx.fillStyle = 'rgba(237,208,92,0.6)';
  ctx.textAlign = 'center';
  ctx.fillText('MINIBRICK', CW / 2, CH - 10);

  canvas.toBlob(blob => {
    if (!blob) return;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'minibrick.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  }, 'image/png');
}

// ===== TOAST =====
function showToast(msg, type) {
  const wrap = document.getElementById('toastWrap');
  const t = document.createElement('div');
  t.className = 'toast ' + (type || ''); t.textContent = msg;
  wrap.appendChild(t);
  setTimeout(() => t.remove(), 2800);
}

// ===== SAVE STATE =====
const FRAME_WIP_KEY = 'mb_frame_wip';
function saveState() {
  // У режимі рамки не чіпаємо набір конструктора брелків, але й не втрачаємо
  // роботу: незавершену фігурку пишемо окремо, щоб після вильоту сайту
  // не збирати її заново.
  if (window.FRAME_MODE) { saveFrameWip(); return; }
  try {
    const s = {
      figures: STATE.figures.map(f => ({ ...f, paintPhotos: [], paintPhotoUrls: f.paintPhotoUrls.filter(u => u && !u.startsWith('blob:')) })),
      currentIdx: STATE.currentIdx
    };
    localStorage.setItem('brickstudio_state', JSON.stringify(s));
  } catch(e) {}
}
// ---- незавершена фігурка в режимі рамки ----
function frameSig(list) {
  try { return JSON.stringify((list || []).map(f => sanitizeForFrame(f))); }
  catch (e) { return ''; }
}
function saveFrameWip() {
  try {
    localStorage.setItem(FRAME_WIP_KEY, JSON.stringify({
      figures: STATE.figures.map(f => ({ ...f, paintPhotos: [] })),
      currentIdx: STATE.currentIdx,
      baseSig: window._frameBaseSig || '',
      at: Date.now(),
    }));
  } catch (e) {}
}
function clearFrameWip() { try { localStorage.removeItem(FRAME_WIP_KEY); } catch (e) {} }

let _resizeTO;
window.addEventListener('resize', () => {
  clearTimeout(_resizeTO);
  _resizeTO = setTimeout(() => { if (STATE.figures.length) updateNavButtons(); }, 150);
});

// ============================================================
// ПОЗНАЧКА ТЕСТОВОЇ ТЕМИ
// Shopify повідомляє сторінці, яка тема зараз відкрита: у опублікованої
// role === 'main', у чернетки — ні. Тому вмикається саме й ніколи
// не з'явиться у клієнтів на живому магазині.
// ============================================================
(function markTestTheme() {
  const t = (window.Shopify || {}).theme || {};
  const role = String(t.role || '').toLowerCase();
  if (!role || role === 'main') return;          // жива тема — мовчимо

  const show = () => {
    if (document.getElementById('mbTestBadge')) return;

    // постійна смужка згори, щоб було видно завжди
    const bar = document.createElement('div');
    bar.id = 'mbTestBadge';
    bar.textContent = '⚠ ТЕСТОВА ТЕМА · ' + (t.name || 'чернетка');
    bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483646;' +
      'background:#FF4757;color:#fff;font:700 12px/1.6 Nunito,sans-serif;' +
      'text-align:center;padding:4px 8px;letter-spacing:.03em;pointer-events:none';
    document.body.appendChild(bar);

    // одноразове вікно з кнопкою ОК
    if (sessionStorage.getItem('mb_test_ok')) return;
    const ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(14,20,34,.92);' +
      'display:flex;align-items:center;justify-content:center;padding:20px';
    ov.innerHTML = '<div style="max-width:340px;background:#1B2433;border:2px solid #FF4757;' +
      'border-radius:14px;padding:22px;text-align:center;font-family:Nunito,sans-serif;color:#fff">' +
      '<div style="font-size:34px;margin-bottom:10px">🧪</div>' +
      '<div style="font-size:17px;font-weight:800;margin-bottom:8px">Це тестовий конструктор</div>' +
      '<div style="font-size:13px;line-height:1.6;color:#8A97B0;margin-bottom:16px">' +
      'Тема «' + (t.name || 'чернетка') + '». Зміни тут не бачать клієнти — ' +
      'на живому магазині працює стара версія.</div>' +
      '<button id="mbTestOk" style="width:100%;padding:12px;border:none;border-radius:10px;' +
      'background:#EDD05C;color:#0E1422;font:800 15px Nunito,sans-serif;cursor:pointer">ОК</button></div>';
    document.body.appendChild(ov);
    ov.querySelector('#mbTestOk').onclick = () => {
      sessionStorage.setItem('mb_test_ok', '1');
      ov.remove();
    };
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
  else show();
})();
